//////////////////////////////////////////////////////////////////////////////////////////////
// DO NOT MODIFY THIS FILE                                                                  //
// This file is automatically generated by ZenStack CLI and should not be manually updated. //
//////////////////////////////////////////////////////////////////////////////////////////////

/* eslint-disable */

import { type SchemaDef, type AttributeApplication, type FieldDefault, ExpressionUtils } from "@zenstackhq/schema";
export class SchemaType implements SchemaDef {
    provider = {
        type: "postgresql"
    } as const;
    models = {
        User: {
            name: "User",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true
                },
                email: {
                    name: "email",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    attributes: [{ name: "@email", args: [{ name: "message", value: ExpressionUtils.literal("Please enter a valid email address") }] }] as readonly AttributeApplication[]
                },
                emailVerified: {
                    name: "emailVerified",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                phoneNumber: {
                    name: "phoneNumber",
                    type: "String",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^\\+[1-9][0-9]{9,14}$") }, { name: "message", value: ExpressionUtils.literal("Please enter a valid mobile number") }] }] as readonly AttributeApplication[]
                },
                phoneNumberVerified: {
                    name: "phoneNumberVerified",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                givenName: {
                    name: "givenName",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                familyName: {
                    name: "familyName",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                image: {
                    name: "image",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "UserRole",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                privacy: {
                    name: "privacy",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                activeSpaceId: {
                    name: "activeSpaceId",
                    type: "String",
                    optional: true
                },
                repairedAt: {
                    name: "repairedAt",
                    type: "DateTime",
                    optional: true
                },
                spaces: {
                    name: "spaces",
                    type: "SpaceUser",
                    array: true,
                    relation: { opposite: "user" }
                },
                accounts: {
                    name: "accounts",
                    type: "Account",
                    array: true,
                    relation: { opposite: "user" }
                },
                sessions: {
                    name: "sessions",
                    type: "Session",
                    array: true,
                    relation: { opposite: "user" }
                },
                apiKeys: {
                    name: "apiKeys",
                    type: "ApiKey",
                    array: true,
                    relation: { opposite: "user" }
                },
                ownedItems: {
                    name: "ownedItems",
                    type: "OwnedItem",
                    array: true,
                    relation: { opposite: "owner" }
                },
                namedItems: {
                    name: "namedItems",
                    type: "NamedItem",
                    array: true,
                    relation: { opposite: "owner" }
                },
                settings: {
                    name: "settings",
                    type: "SettingValue",
                    array: true,
                    relation: { opposite: "owner" }
                },
                connectionItems: {
                    name: "connectionItems",
                    type: "ConnectionItem",
                    array: true,
                    relation: { opposite: "owner" }
                },
                nickName: {
                    name: "nickName",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(50) }] }] as readonly AttributeApplication[]
                },
                dateOfBirth: {
                    name: "dateOfBirth",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                gender: {
                    name: "gender",
                    type: "Gender",
                    optional: true
                },
                relationship: {
                    name: "relationship",
                    type: "RelationshipStatus",
                    optional: true
                },
                language: {
                    name: "language",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("en") }] }] as readonly AttributeApplication[],
                    default: "en" as FieldDefault
                },
                timezone: {
                    name: "timezone",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(50) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("Etc/GMT") }] }] as readonly AttributeApplication[],
                    default: "Etc/GMT" as FieldDefault
                },
                firstDayOfWeek: {
                    name: "firstDayOfWeek",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(7) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(7) }] }] as readonly AttributeApplication[],
                    default: 7 as FieldDefault
                },
                citizenship: {
                    name: "citizenship",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }] as readonly AttributeApplication[]
                },
                country: {
                    name: "country",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }] as readonly AttributeApplication[]
                },
                state: {
                    name: "state",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(50) }] }] as readonly AttributeApplication[]
                },
                city: {
                    name: "city",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(50) }] }] as readonly AttributeApplication[]
                },
                coachId: {
                    name: "coachId",
                    type: "CoachId",
                    optional: true
                },
                onboardingTrack: {
                    name: "onboardingTrack",
                    type: "OnboardingTrack",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("comprehensive") }] }] as readonly AttributeApplication[],
                    default: "comprehensive" as FieldDefault
                },
                verbosity: {
                    name: "verbosity",
                    type: "Verbosity",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("auto") }] }] as readonly AttributeApplication[],
                    default: "auto" as FieldDefault
                },
                journeyStepId: {
                    name: "journeyStepId",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(30) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("initial-intake") }] }] as readonly AttributeApplication[],
                    default: "initial-intake" as FieldDefault
                },
                lifeDomainIds: {
                    name: "lifeDomainIds",
                    type: "LifeDomainId",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                cohort: {
                    name: "cohort",
                    type: "String",
                    optional: true
                },
                acqChannel: {
                    name: "acqChannel",
                    type: "String",
                    optional: true
                },
                utmSource: {
                    name: "utmSource",
                    type: "String",
                    optional: true
                },
                utmMedium: {
                    name: "utmMedium",
                    type: "String",
                    optional: true
                },
                utmCampaign: {
                    name: "utmCampaign",
                    type: "String",
                    optional: true
                },
                suprSendInboxId: {
                    name: "suprSendInboxId",
                    type: "String",
                    optional: true
                },
                iosPushToken: {
                    name: "iosPushToken",
                    type: "String",
                    optional: true
                },
                wakeup: {
                    name: "wakeup",
                    type: "String",
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("07:00:00") }] }] as readonly AttributeApplication[],
                    default: "07:00:00" as FieldDefault
                },
                morning: {
                    name: "morning",
                    type: "String",
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("09:00:00") }] }] as readonly AttributeApplication[],
                    default: "09:00:00" as FieldDefault
                },
                lunch: {
                    name: "lunch",
                    type: "String",
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("12:00:00") }] }] as readonly AttributeApplication[],
                    default: "12:00:00" as FieldDefault
                },
                afternoon: {
                    name: "afternoon",
                    type: "String",
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("13:00:00") }] }] as readonly AttributeApplication[],
                    default: "13:00:00" as FieldDefault
                },
                dinner: {
                    name: "dinner",
                    type: "String",
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("18:00:00") }] }] as readonly AttributeApplication[],
                    default: "18:00:00" as FieldDefault
                },
                evening: {
                    name: "evening",
                    type: "String",
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("19:00:00") }] }] as readonly AttributeApplication[],
                    default: "19:00:00" as FieldDefault
                },
                bedtime: {
                    name: "bedtime",
                    type: "String",
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("22:00:00") }] }] as readonly AttributeApplication[],
                    default: "22:00:00" as FieldDefault
                },
                disableAdmin: {
                    name: "disableAdmin",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                email: { type: "String" },
                phoneNumber: { type: "String" }
            }
        },
        Account: {
            name: "Account",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                providerId: {
                    name: "providerId",
                    type: "String"
                },
                accessToken: {
                    name: "accessToken",
                    type: "String",
                    optional: true
                },
                refreshToken: {
                    name: "refreshToken",
                    type: "String",
                    optional: true
                },
                accessTokenExpiresAt: {
                    name: "accessTokenExpiresAt",
                    type: "DateTime",
                    optional: true
                },
                refreshTokenExpiresAt: {
                    name: "refreshTokenExpiresAt",
                    type: "DateTime",
                    optional: true
                },
                scope: {
                    name: "scope",
                    type: "String",
                    optional: true
                },
                idToken: {
                    name: "idToken",
                    type: "String",
                    optional: true
                },
                password: {
                    name: "password",
                    type: "String",
                    optional: true,
                    omit: true
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "accounts", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Space: {
            name: "Space",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                name: {
                    name: "name",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(50) }, { name: "message", value: ExpressionUtils.literal("Name must be between 3 and 50 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                members: {
                    name: "members",
                    type: "SpaceUser",
                    array: true,
                    relation: { opposite: "space" }
                },
                ownedItems: {
                    name: "ownedItems",
                    type: "OwnedItem",
                    array: true,
                    relation: { opposite: "space" }
                },
                namedItems: {
                    name: "namedItems",
                    type: "NamedItem",
                    array: true,
                    relation: { opposite: "space" }
                },
                settings: {
                    name: "settings",
                    type: "SettingValue",
                    array: true,
                    relation: { opposite: "space" }
                },
                connectionItems: {
                    name: "connectionItems",
                    type: "ConnectionItem",
                    array: true,
                    relation: { opposite: "space" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        SpaceUser: {
            name: "SpaceUser",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "spaces", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                space: {
                    name: "space",
                    type: "Space",
                    relation: { opposite: "members", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                role: {
                    name: "role",
                    type: "SpaceUserRole"
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                userId_spaceId: { userId: { type: "String" }, spaceId: { type: "String" } }
            }
        },
        SettingValue: {
            name: "SettingValue",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    relation: { opposite: "settings", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    relation: { opposite: "settings", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                key: {
                    name: "key",
                    type: "String",
                    fuzzy: true,
                    foreignKeyFor: [
                        "template"
                    ] as readonly string[]
                },
                type: {
                    name: "type",
                    type: "SettingType"
                },
                value: {
                    name: "value",
                    type: "String",
                    fullText: true
                },
                group: {
                    name: "group",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    foreignKeyFor: [
                        "template"
                    ] as readonly string[]
                },
                public: {
                    name: "public",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                app: {
                    name: "app",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("uvilo-ai") }] }] as readonly AttributeApplication[],
                    default: "uvilo-ai" as FieldDefault
                },
                template: {
                    name: "template",
                    type: "SettingTemplate",
                    optional: true,
                    relation: { opposite: "settingValues", fields: ["group", "key"], references: ["group", "key"] }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                ownerId_group_key_app: { ownerId: { type: "String" }, group: { type: "String" }, key: { type: "String" }, app: { type: "String" } }
            }
        },
        SettingTemplate: {
            name: "SettingTemplate",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                spot: {
                    name: "spot",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("other") }] }] as readonly AttributeApplication[],
                    default: "other" as FieldDefault
                },
                group: {
                    name: "group",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("other") }] }] as readonly AttributeApplication[],
                    default: "other" as FieldDefault
                },
                key: {
                    name: "key",
                    type: "String"
                },
                type: {
                    name: "type",
                    type: "SettingType"
                },
                values: {
                    name: "values",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                default: {
                    name: "default",
                    type: "String"
                },
                icon: {
                    name: "icon",
                    type: "String",
                    optional: true
                },
                public: {
                    name: "public",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                apps: {
                    name: "apps",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                settingValues: {
                    name: "settingValues",
                    type: "SettingValue",
                    array: true,
                    relation: { opposite: "template" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                group_key: { group: { type: "String" }, key: { type: "String" } }
            }
        },
        OwnedItem: {
            name: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            },
            isDelegate: true,
            subModels: ["Factoid", "Rating", "ItemLabel", "ChildPrompt", "CloudImage", "UserMetric", "QuizQuestionResult", "UserProgram", "ToolSetEntry", "AiStep", "Execution", "AiMessage", "Feedback", "ConnectionSession", "UserMetricGroup", "DashboardWidget", "Notification", "Journey"]
        },
        Factoid: {
            name: "Factoid",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                app: {
                    name: "app",
                    type: "String"
                },
                category1: {
                    name: "category1",
                    type: "String"
                },
                category2: {
                    name: "category2",
                    type: "String"
                },
                text: {
                    name: "text",
                    type: "String",
                    fuzzy: true,
                    fullText: true
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true
                },
                date: {
                    name: "date",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                convoId: {
                    name: "convoId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "convo"
                    ] as readonly string[]
                },
                convo: {
                    name: "convo",
                    type: "Convo",
                    optional: true,
                    relation: { opposite: "factoids", fields: ["convoId"], references: ["id"], onDelete: "Cascade" }
                },
                provenanceId: {
                    name: "provenanceId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "provenance"
                    ] as readonly string[]
                },
                provenance: {
                    name: "provenance",
                    type: "OwnedItem",
                    optional: true,
                    relation: { opposite: "factoidsAsProvenance", name: "FactoidProvenance", fields: ["provenanceId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Convo: {
            name: "Convo",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                botId: {
                    name: "botId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "bot"
                    ] as readonly string[]
                },
                bot: {
                    name: "bot",
                    type: "Bot",
                    optional: true,
                    relation: { opposite: "convos", fields: ["botId"], references: ["id"] }
                },
                botName: {
                    name: "botName",
                    type: "String",
                    optional: true
                },
                botGroup: {
                    name: "botGroup",
                    type: "String",
                    optional: true
                },
                botHandle: {
                    name: "botHandle",
                    type: "String",
                    optional: true
                },
                avatarId: {
                    name: "avatarId",
                    type: "String",
                    optional: true
                },
                avatarName: {
                    name: "avatarName",
                    type: "String",
                    optional: true
                },
                useCase: {
                    name: "useCase",
                    type: "String",
                    optional: true
                },
                integration: {
                    name: "integration",
                    type: "String"
                },
                modelName: {
                    name: "modelName",
                    type: "String"
                },
                workspaceRoot: {
                    name: "workspaceRoot",
                    type: "String",
                    optional: true
                },
                serviceTier: {
                    name: "serviceTier",
                    type: "ServiceTier",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("default") }] }] as readonly AttributeApplication[],
                    default: "default" as FieldDefault
                },
                temperature: {
                    name: "temperature",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                reasoningEffort: {
                    name: "reasoningEffort",
                    type: "ReasoningEffort",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("medium") }] }] as readonly AttributeApplication[],
                    default: "medium" as FieldDefault
                },
                verbosity: {
                    name: "verbosity",
                    type: "ConvoVerbosity",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("medium") }] }] as readonly AttributeApplication[],
                    default: "medium" as FieldDefault
                },
                toolAccessMode: {
                    name: "toolAccessMode",
                    type: "ToolAccessMode",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("READ_WRITE") }] }] as readonly AttributeApplication[],
                    default: "READ_WRITE" as FieldDefault
                },
                systemPrompt: {
                    name: "systemPrompt",
                    type: "String"
                },
                appendPromptId: {
                    name: "appendPromptId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "appendPrompt"
                    ] as readonly string[]
                },
                appendPrompt: {
                    name: "appendPrompt",
                    type: "Prompt",
                    optional: true,
                    relation: { opposite: "convosWithAppendPrompt", fields: ["appendPromptId"], references: ["id"], onDelete: "SetNull" }
                },
                appendPromptValues: {
                    name: "appendPromptValues",
                    type: "Json",
                    optional: true
                },
                systemMessage: {
                    name: "systemMessage",
                    type: "String",
                    optional: true
                },
                autoStart: {
                    name: "autoStart",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                toolSetId: {
                    name: "toolSetId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("tls_notools") }] }] as readonly AttributeApplication[],
                    default: "tls_notools" as FieldDefault
                },
                type: {
                    name: "type",
                    type: "ConvoType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("chat") }] }] as readonly AttributeApplication[],
                    default: "chat" as FieldDefault
                },
                maxSteps: {
                    name: "maxSteps",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(10) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 10 as FieldDefault
                },
                executionId: {
                    name: "executionId",
                    type: "String",
                    optional: true
                },
                activeStreamId: {
                    name: "activeStreamId",
                    type: "String",
                    optional: true
                },
                timezone: {
                    name: "timezone",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(50) }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("Etc/GMT") }] }] as readonly AttributeApplication[],
                    default: "Etc/GMT" as FieldDefault
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                closedAt: {
                    name: "closedAt",
                    type: "DateTime",
                    optional: true
                },
                analyzedAt: {
                    name: "analyzedAt",
                    type: "DateTime",
                    optional: true
                },
                spawnMode: {
                    name: "spawnMode",
                    type: "ConvoSpawnMode",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("direct") }] }] as readonly AttributeApplication[],
                    default: "direct" as FieldDefault
                },
                depth: {
                    name: "depth",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                steps: {
                    name: "steps",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                project: {
                    name: "project",
                    type: "String",
                    optional: true
                },
                completionEventName: {
                    name: "completionEventName",
                    type: "String",
                    optional: true
                },
                completionEventData: {
                    name: "completionEventData",
                    type: "Json",
                    optional: true
                },
                completionEventFiredAt: {
                    name: "completionEventFiredAt",
                    type: "DateTime",
                    optional: true
                },
                forgePhaseFinish: {
                    name: "forgePhaseFinish",
                    type: "Json",
                    optional: true
                },
                durationSecs: {
                    name: "durationSecs",
                    type: "Int",
                    optional: true
                },
                analysisBotGroup: {
                    name: "analysisBotGroup",
                    type: "String",
                    optional: true
                },
                analysisBotHandle: {
                    name: "analysisBotHandle",
                    type: "String",
                    optional: true
                },
                analysisSchema: {
                    name: "analysisSchema",
                    type: "String",
                    optional: true
                },
                analysisAppendPromptId: {
                    name: "analysisAppendPromptId",
                    type: "String",
                    optional: true
                },
                analysis: {
                    name: "analysis",
                    type: "Json",
                    optional: true
                },
                output: {
                    name: "output",
                    type: "Json",
                    optional: true
                },
                outputSchema: {
                    name: "outputSchema",
                    type: "String",
                    optional: true
                },
                inputTokens: {
                    name: "inputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                outputTokens: {
                    name: "outputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                reasoningTokens: {
                    name: "reasoningTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cachedInputTokens: {
                    name: "cachedInputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cacheWriteTokens: {
                    name: "cacheWriteTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                audioInputSeconds: {
                    name: "audioInputSeconds",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                inTotalCost: {
                    name: "inTotalCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                outTotalCost: {
                    name: "outTotalCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                aiMessages: {
                    name: "aiMessages",
                    type: "AiMessage",
                    array: true,
                    relation: { opposite: "convo" }
                },
                aiSteps: {
                    name: "aiSteps",
                    type: "AiStep",
                    array: true,
                    relation: { opposite: "convo" }
                },
                artifacts: {
                    name: "artifacts",
                    type: "Artifact",
                    array: true,
                    relation: { opposite: "convo" }
                },
                factoids: {
                    name: "factoids",
                    type: "Factoid",
                    array: true,
                    relation: { opposite: "convo" }
                },
                parentConvoId: {
                    name: "parentConvoId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "parentConvo"
                    ] as readonly string[]
                },
                parentConvo: {
                    name: "parentConvo",
                    type: "Convo",
                    optional: true,
                    relation: { opposite: "childConvos", name: "ConvoSpawnTree", fields: ["parentConvoId"], references: ["id"] }
                },
                childConvos: {
                    name: "childConvos",
                    type: "Convo",
                    array: true,
                    relation: { opposite: "parentConvo", name: "ConvoSpawnTree" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        NamedItem: {
            name: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    isDiscriminator: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            },
            isDelegate: true,
            subModels: ["Convo", "Label", "Bot", "Prompt", "Program", "Metric", "Habit", "Event", "Unit", "Quiz", "QuizResult", "ToolSet", "Artifact", "MetricGroup", "TodoList", "TodoItem"]
        },
        Rating: {
            name: "Rating",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                type: {
                    name: "type",
                    type: "RatingType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("four_thumbs") }] }] as readonly AttributeApplication[],
                    default: "four_thumbs" as FieldDefault
                },
                value: {
                    name: "value",
                    type: "Int",
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(-2) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(2) }] }] as readonly AttributeApplication[]
                },
                comment: {
                    name: "comment",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(0) }, { name: "max", value: ExpressionUtils.literal(5000) }] }] as readonly AttributeApplication[]
                },
                namedItemId: {
                    name: "namedItemId",
                    type: "String",
                    foreignKeyFor: [
                        "namedItem"
                    ] as readonly string[]
                },
                namedItem: {
                    name: "namedItem",
                    type: "NamedItem",
                    relation: { opposite: "ratings", fields: ["namedItemId"], references: ["id"], onDelete: "Cascade" }
                },
                submittedAt: {
                    name: "submittedAt",
                    type: "DateTime",
                    optional: true
                },
                readAt: {
                    name: "readAt",
                    type: "DateTime",
                    optional: true
                },
                closedAt: {
                    name: "closedAt",
                    type: "DateTime",
                    optional: true
                },
                notes: {
                    name: "notes",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(0) }, { name: "max", value: ExpressionUtils.literal(5000) }] }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Label: {
            name: "Label",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                listId: {
                    name: "listId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("bots") }] }] as readonly AttributeApplication[],
                    default: "bots" as FieldDefault
                },
                type: {
                    name: "type",
                    type: "LabelType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("CUSTOM") }] }] as readonly AttributeApplication[],
                    default: "CUSTOM" as FieldDefault
                },
                key: {
                    name: "key",
                    type: "String",
                    optional: true
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(2) }] }] as readonly AttributeApplication[],
                    default: 2 as FieldDefault
                },
                locked: {
                    name: "locked",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                items: {
                    name: "items",
                    type: "ItemLabel",
                    array: true,
                    relation: { opposite: "label", name: "LabelItems" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        ItemLabel: {
            name: "ItemLabel",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                itemId: {
                    name: "itemId",
                    type: "String",
                    foreignKeyFor: [
                        "item"
                    ] as readonly string[]
                },
                item: {
                    name: "item",
                    type: "NamedItem",
                    relation: { opposite: "labels", fields: ["itemId"], references: ["id"], onDelete: "Cascade" }
                },
                labelId: {
                    name: "labelId",
                    type: "String",
                    foreignKeyFor: [
                        "label"
                    ] as readonly string[]
                },
                label: {
                    name: "label",
                    type: "Label",
                    relation: { opposite: "items", name: "LabelItems", fields: ["labelId"], references: ["id"], onDelete: "Cascade" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                itemId_labelId: { itemId: { type: "String" }, labelId: { type: "String" } }
            }
        },
        Bot: {
            name: "Bot",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                group: {
                    name: "group",
                    type: "String",
                    optional: true
                },
                handle: {
                    name: "handle",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                avatarId: {
                    name: "avatarId",
                    type: "String",
                    optional: true
                },
                useCase: {
                    name: "useCase",
                    type: "String",
                    optional: true
                },
                integration: {
                    name: "integration",
                    type: "String",
                    optional: true
                },
                modelName: {
                    name: "modelName",
                    type: "String",
                    optional: true
                },
                serviceTier: {
                    name: "serviceTier",
                    type: "ServiceTier",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("default") }] }] as readonly AttributeApplication[],
                    default: "default" as FieldDefault
                },
                maxSteps: {
                    name: "maxSteps",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(10) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 10 as FieldDefault
                },
                temperature: {
                    name: "temperature",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                reasoningEffort: {
                    name: "reasoningEffort",
                    type: "ReasoningEffort",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("medium") }] }] as readonly AttributeApplication[],
                    default: "medium" as FieldDefault
                },
                verbosity: {
                    name: "verbosity",
                    type: "ConvoVerbosity",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("medium") }] }] as readonly AttributeApplication[],
                    default: "medium" as FieldDefault
                },
                toolAccessMode: {
                    name: "toolAccessMode",
                    type: "ToolAccessMode",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("READ_WRITE") }] }] as readonly AttributeApplication[],
                    default: "READ_WRITE" as FieldDefault
                },
                systemPromptValues: {
                    name: "systemPromptValues",
                    type: "Json",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("{}") }] }] as readonly AttributeApplication[],
                    default: "{}" as FieldDefault
                },
                autoStart: {
                    name: "autoStart",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                analysisBotGroup: {
                    name: "analysisBotGroup",
                    type: "String",
                    optional: true
                },
                analysisBotHandle: {
                    name: "analysisBotHandle",
                    type: "String",
                    optional: true
                },
                analysisSchema: {
                    name: "analysisSchema",
                    type: "String",
                    optional: true
                },
                outputSchema: {
                    name: "outputSchema",
                    type: "String",
                    optional: true
                },
                convos: {
                    name: "convos",
                    type: "Convo",
                    array: true,
                    relation: { opposite: "bot" }
                },
                aiSteps: {
                    name: "aiSteps",
                    type: "AiStep",
                    array: true,
                    relation: { opposite: "bot" }
                },
                childPrompts: {
                    name: "childPrompts",
                    type: "ChildPrompt",
                    array: true,
                    relation: { opposite: "parentBot", name: "ChildPrompts" }
                },
                toolSetId: {
                    name: "toolSetId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("tls_notools") }] }] as readonly AttributeApplication[],
                    default: "tls_notools" as FieldDefault,
                    foreignKeyFor: [
                        "toolSet"
                    ] as readonly string[]
                },
                toolSet: {
                    name: "toolSet",
                    type: "ToolSet",
                    relation: { opposite: "bots", fields: ["toolSetId"], references: ["id"], onDelete: "Restrict", hasDefault: true }
                }
            },
            attributes: [
                { name: "@@validate", args: [{ name: "value", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("useCase"), "!=", ExpressionUtils._null()), "||", ExpressionUtils.binary(ExpressionUtils.field("modelName"), "!=", ExpressionUtils._null())) }, { name: "message", value: ExpressionUtils.literal("A Bot needs a use case or a model") }, { name: "path", value: ExpressionUtils.array("String", [ExpressionUtils.literal("useCase"), ExpressionUtils.literal("modelName")]) }] },
                { name: "@@validate", args: [{ name: "value", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("integration"), "==", ExpressionUtils._null()), "==", ExpressionUtils.binary(ExpressionUtils.field("modelName"), "==", ExpressionUtils._null())) }, { name: "message", value: ExpressionUtils.literal("integration is set exactly when modelName is set") }, { name: "path", value: ExpressionUtils.array("String", [ExpressionUtils.literal("integration"), ExpressionUtils.literal("modelName")]) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" },
                group_handle: { group: { type: "String" }, handle: { type: "String" } }
            }
        },
        Prompt: {
            name: "Prompt",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                text: {
                    name: "text",
                    type: "String",
                    fullText: true
                },
                variables: {
                    name: "variables",
                    type: "PromptVariable",
                    array: true
                },
                script: {
                    name: "script",
                    type: "String",
                    optional: true
                },
                group: {
                    name: "group",
                    type: "String",
                    optional: true
                },
                handle: {
                    name: "handle",
                    type: "String",
                    optional: true
                },
                parentPrompts: {
                    name: "parentPrompts",
                    type: "ChildPrompt",
                    array: true,
                    relation: { opposite: "prompt", name: "ParentPrompts" }
                },
                childPrompts: {
                    name: "childPrompts",
                    type: "ChildPrompt",
                    array: true,
                    relation: { opposite: "parentPrompt", name: "ChildPrompts" }
                },
                versions: {
                    name: "versions",
                    type: "PromptVersion",
                    array: true,
                    relation: { opposite: "prompt" }
                },
                convosWithAppendPrompt: {
                    name: "convosWithAppendPrompt",
                    type: "Convo",
                    array: true,
                    relation: { opposite: "appendPrompt" }
                },
                programSteps: {
                    name: "programSteps",
                    type: "ProgramStep",
                    array: true,
                    relation: { opposite: "prompt" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" },
                handle: { type: "String" }
            }
        },
        PromptVersion: {
            name: "PromptVersion",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                promptId: {
                    name: "promptId",
                    type: "String",
                    foreignKeyFor: [
                        "prompt"
                    ] as readonly string[]
                },
                prompt: {
                    name: "prompt",
                    type: "Prompt",
                    relation: { opposite: "versions", fields: ["promptId"], references: ["id"], onDelete: "Cascade" }
                },
                version: {
                    name: "version",
                    type: "Int"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                text: {
                    name: "text",
                    type: "String"
                },
                variables: {
                    name: "variables",
                    type: "PromptVariable",
                    array: true
                },
                script: {
                    name: "script",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                promptId_version: { promptId: { type: "String" }, version: { type: "Int" } }
            }
        },
        ChildPrompt: {
            name: "ChildPrompt",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                parentBotId: {
                    name: "parentBotId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "parentBot"
                    ] as readonly string[]
                },
                parentBot: {
                    name: "parentBot",
                    type: "Bot",
                    optional: true,
                    relation: { opposite: "childPrompts", name: "ChildPrompts", fields: ["parentBotId"], references: ["id"], onDelete: "Cascade" }
                },
                parentPromptId: {
                    name: "parentPromptId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "parentPrompt"
                    ] as readonly string[]
                },
                parentPrompt: {
                    name: "parentPrompt",
                    type: "Prompt",
                    optional: true,
                    relation: { opposite: "childPrompts", name: "ChildPrompts", fields: ["parentPromptId"], references: ["id"], onDelete: "Cascade" }
                },
                promptId: {
                    name: "promptId",
                    type: "String",
                    foreignKeyFor: [
                        "prompt"
                    ] as readonly string[]
                },
                prompt: {
                    name: "prompt",
                    type: "Prompt",
                    relation: { opposite: "parentPrompts", name: "ParentPrompts", fields: ["promptId"], references: ["id"], onDelete: "Cascade" }
                },
                values: {
                    name: "values",
                    type: "Json",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("{}") }] }] as readonly AttributeApplication[],
                    default: "{}" as FieldDefault
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                parentBotId_parentPromptId_promptId: { parentBotId: { type: "String" }, parentPromptId: { type: "String" }, promptId: { type: "String" } }
            }
        },
        ProgramStep: {
            name: "ProgramStep",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                programId: {
                    name: "programId",
                    type: "String",
                    foreignKeyFor: [
                        "program"
                    ] as readonly string[]
                },
                program: {
                    name: "program",
                    type: "Program",
                    relation: { opposite: "steps", fields: ["programId"], references: ["id"], onDelete: "Cascade" }
                },
                lessonId: {
                    name: "lessonId",
                    type: "String",
                    foreignKeyFor: [
                        "lesson"
                    ] as readonly string[]
                },
                lesson: {
                    name: "lesson",
                    type: "ProgramLesson",
                    relation: { opposite: "steps", fields: ["lessonId"], references: ["id"], onDelete: "Cascade" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String"
                },
                type: {
                    name: "type",
                    type: "ProgramStepType"
                },
                contentSecs: {
                    name: "contentSecs",
                    type: "Int",
                    optional: true
                },
                content: {
                    name: "content",
                    type: "String",
                    optional: true
                },
                videoUrl: {
                    name: "videoUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                resourceItemId: {
                    name: "resourceItemId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "resourceItem"
                    ] as readonly string[]
                },
                resourceItem: {
                    name: "resourceItem",
                    type: "ResourceItem",
                    optional: true,
                    relation: { opposite: "programSteps", fields: ["resourceItemId"], references: ["id"], onDelete: "SetNull" }
                },
                botGroup: {
                    name: "botGroup",
                    type: "String",
                    optional: true
                },
                botHandle: {
                    name: "botHandle",
                    type: "String",
                    optional: true
                },
                promptId: {
                    name: "promptId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "prompt"
                    ] as readonly string[]
                },
                prompt: {
                    name: "prompt",
                    type: "Prompt",
                    optional: true,
                    relation: { opposite: "programSteps", fields: ["promptId"], references: ["id"], onDelete: "SetNull" }
                },
                outputSchema: {
                    name: "outputSchema",
                    type: "String",
                    optional: true
                },
                analysisBotGroup: {
                    name: "analysisBotGroup",
                    type: "String",
                    optional: true
                },
                analysisBotHandle: {
                    name: "analysisBotHandle",
                    type: "String",
                    optional: true
                },
                analysisPromptId: {
                    name: "analysisPromptId",
                    type: "String",
                    optional: true
                },
                analysisSchema: {
                    name: "analysisSchema",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ResourceItem: {
            name: "ResourceItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(30) }, { name: "max", value: ExpressionUtils.literal(250) }] }] as readonly AttributeApplication[]
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    foreignKeyFor: [
                        "lifeDomain"
                    ] as readonly string[]
                },
                lifeDomain: {
                    name: "lifeDomain",
                    type: "LifeDomain",
                    relation: { opposite: "resourceItems", fields: ["domain"], references: ["domainId"] }
                },
                language: {
                    name: "language",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("en") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z]{2}$") }] }] as readonly AttributeApplication[],
                    default: "en" as FieldDefault
                },
                coverImageId: {
                    name: "coverImageId",
                    type: "String",
                    optional: true
                },
                score: {
                    name: "score",
                    type: "Float",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                category: {
                    name: "category",
                    type: "String",
                    optional: true
                },
                categories: {
                    name: "categories",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                publishedOn: {
                    name: "publishedOn",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                websiteUrl: {
                    name: "websiteUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                copyright: {
                    name: "copyright",
                    type: "String",
                    optional: true
                },
                resTaxonomies: {
                    name: "resTaxonomies",
                    type: "ResTaxonomy",
                    array: true,
                    relation: { opposite: "resourceItem" }
                },
                resAuthors: {
                    name: "resAuthors",
                    type: "ResAuthor",
                    array: true,
                    relation: { opposite: "resource" }
                },
                resourceLinks: {
                    name: "resourceLinks",
                    type: "ResourceLink",
                    array: true,
                    relation: { opposite: "resourceItem" }
                },
                cloudImages: {
                    name: "cloudImages",
                    type: "CloudImage",
                    array: true,
                    relation: { opposite: "resourceItem" }
                },
                transcripts: {
                    name: "transcripts",
                    type: "Transcript",
                    array: true,
                    relation: { opposite: "resourceItem" }
                },
                sources: {
                    name: "sources",
                    type: "Source",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                programSteps: {
                    name: "programSteps",
                    type: "ProgramStep",
                    array: true,
                    relation: { opposite: "resourceItem" }
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    isDiscriminator: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug_version: { slug: { type: "String" }, version: { type: "Int" } },
                title_itemType_version: { title: { type: "String" }, itemType: { type: "String" }, version: { type: "Int" } }
            },
            isDelegate: true,
            subModels: ["Book", "Podcast", "Channel", "Video", "PodEpisode"]
        },
        ResTaxonomy: {
            name: "ResTaxonomy",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                similarity: {
                    name: "similarity",
                    type: "Float",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                taxonomyId: {
                    name: "taxonomyId",
                    type: "String",
                    foreignKeyFor: [
                        "taxonomy"
                    ] as readonly string[]
                },
                taxonomy: {
                    name: "taxonomy",
                    type: "Taxonomy",
                    relation: { opposite: "resTaxonomies", fields: ["taxonomyId"], references: ["id"], onDelete: "Cascade" }
                },
                resourceItemId: {
                    name: "resourceItemId",
                    type: "String",
                    foreignKeyFor: [
                        "resourceItem"
                    ] as readonly string[]
                },
                resourceItem: {
                    name: "resourceItem",
                    type: "ResourceItem",
                    relation: { opposite: "resTaxonomies", fields: ["resourceItemId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                taxonomyId_resourceItemId: { taxonomyId: { type: "String" }, resourceItemId: { type: "String" } }
            }
        },
        CloudImage: {
            name: "CloudImage",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                assetId: {
                    name: "assetId",
                    type: "String",
                    unique: true
                },
                assetVersion: {
                    name: "assetVersion",
                    type: "String"
                },
                fullAssetId: {
                    name: "fullAssetId",
                    type: "String"
                },
                secureUrl: {
                    name: "secureUrl",
                    type: "String",
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                format: {
                    name: "format",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(10) }] }] as readonly AttributeApplication[]
                },
                width: {
                    name: "width",
                    type: "Int",
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[]
                },
                height: {
                    name: "height",
                    type: "Int",
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[]
                },
                bytes: {
                    name: "bytes",
                    type: "Int",
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                resourceItemId: {
                    name: "resourceItemId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "resourceItem"
                    ] as readonly string[]
                },
                resourceItem: {
                    name: "resourceItem",
                    type: "ResourceItem",
                    optional: true,
                    relation: { opposite: "cloudImages", fields: ["resourceItemId"], references: ["id"], onDelete: "SetNull" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                assetId: { type: "String" }
            }
        },
        Taxonomy: {
            name: "Taxonomy",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(50) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 50 characters") }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    fullText: true
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("body") }] }] as readonly AttributeApplication[],
                    default: "body" as FieldDefault
                },
                type: {
                    name: "type",
                    type: "TaxonomyType"
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true
                },
                mapsFrom: {
                    name: "mapsFrom",
                    type: "TaxonomyMap",
                    array: true,
                    relation: { opposite: "from", name: "mapsFrom" }
                },
                mapsTo: {
                    name: "mapsTo",
                    type: "TaxonomyMap",
                    array: true,
                    relation: { opposite: "to", name: "mapsTo" }
                },
                resTaxonomies: {
                    name: "resTaxonomies",
                    type: "ResTaxonomy",
                    array: true,
                    relation: { opposite: "taxonomy" }
                },
                programs: {
                    name: "programs",
                    type: "Program",
                    array: true,
                    relation: { opposite: "practice" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        TaxonomyMap: {
            name: "TaxonomyMap",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                fromId: {
                    name: "fromId",
                    type: "String",
                    foreignKeyFor: [
                        "from"
                    ] as readonly string[]
                },
                from: {
                    name: "from",
                    type: "Taxonomy",
                    relation: { opposite: "mapsFrom", name: "mapsFrom", fields: ["fromId"], references: ["id"], onDelete: "Cascade" }
                },
                toId: {
                    name: "toId",
                    type: "String",
                    foreignKeyFor: [
                        "to"
                    ] as readonly string[]
                },
                to: {
                    name: "to",
                    type: "Taxonomy",
                    relation: { opposite: "mapsTo", name: "mapsTo", fields: ["toId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                fromId_toId: { fromId: { type: "String" }, toId: { type: "String" } }
            }
        },
        LifeDomain: {
            name: "LifeDomain",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                domainId: {
                    name: "domainId",
                    type: "LifeDomainId",
                    unique: true
                },
                number: {
                    name: "number",
                    type: "Int",
                    unique: true
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(50) }, { name: "message", value: ExpressionUtils.literal("Title must be between 1 and 50 characters") }] }] as readonly AttributeApplication[]
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Subtitle must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    fullText: true
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                conditional: {
                    name: "conditional",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                icon: {
                    name: "icon",
                    type: "String",
                    optional: true
                },
                imageId: {
                    name: "imageId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("Illustrations/Ekaterina/meditator_blue") }] }] as readonly AttributeApplication[],
                    default: "Illustrations/Ekaterina/meditator_blue" as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true
                },
                resourceItems: {
                    name: "resourceItems",
                    type: "ResourceItem",
                    array: true,
                    relation: { opposite: "lifeDomain" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                domainId: { type: "LifeDomainId" },
                number: { type: "Int" }
            }
        },
        Program: {
            name: "Program",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                handle: {
                    name: "handle",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(40) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z0-9-]+$") }] }] as readonly AttributeApplication[]
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                tagline: {
                    name: "tagline",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                epigraph: {
                    name: "epigraph",
                    type: "String",
                    optional: true
                },
                customizationNote: {
                    name: "customizationNote",
                    type: "String",
                    optional: true
                },
                coverImageId: {
                    name: "coverImageId",
                    type: "String",
                    optional: true
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("general") }] }] as readonly AttributeApplication[],
                    default: "general" as FieldDefault
                },
                practiceId: {
                    name: "practiceId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "practice"
                    ] as readonly string[]
                },
                practice: {
                    name: "practice",
                    type: "Taxonomy",
                    optional: true,
                    relation: { opposite: "programs", fields: ["practiceId"], references: ["id"], onDelete: "SetNull" }
                },
                level: {
                    name: "level",
                    type: "ProgramLevel",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("beginner") }] }] as readonly AttributeApplication[],
                    default: "beginner" as FieldDefault
                },
                days: {
                    name: "days",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(90) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(730) }] }] as readonly AttributeApplication[],
                    default: 90 as FieldDefault
                },
                timePerWeekMinMinutes: {
                    name: "timePerWeekMinMinutes",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                timePerWeekMaxMinutes: {
                    name: "timePerWeekMaxMinutes",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                showPhaseNumbers: {
                    name: "showPhaseNumbers",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                showLessonNumbers: {
                    name: "showLessonNumbers",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                showStepNumbers: {
                    name: "showStepNumbers",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                outcomeMetricId: {
                    name: "outcomeMetricId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "outcomeMetric"
                    ] as readonly string[]
                },
                outcomeMetric: {
                    name: "outcomeMetric",
                    type: "Metric",
                    optional: true,
                    relation: { opposite: "outcomePrograms", name: "ProgramOutcomeMetric", fields: ["outcomeMetricId"], references: ["id"], onDelete: "SetNull" }
                },
                designEventId: {
                    name: "designEventId",
                    type: "String",
                    unique: true,
                    optional: true
                },
                legacyId: {
                    name: "legacyId",
                    type: "String",
                    unique: true,
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                contentSecs: {
                    name: "contentSecs",
                    type: "Int",
                    optional: true
                },
                phases: {
                    name: "phases",
                    type: "ProgramPhase",
                    array: true,
                    relation: { opposite: "program" }
                },
                lessons: {
                    name: "lessons",
                    type: "ProgramLesson",
                    array: true,
                    relation: { opposite: "program" }
                },
                steps: {
                    name: "steps",
                    type: "ProgramStep",
                    array: true,
                    relation: { opposite: "program" }
                },
                habits: {
                    name: "habits",
                    type: "ProgramHabit",
                    array: true,
                    relation: { opposite: "program" }
                },
                metrics: {
                    name: "metrics",
                    type: "ProgramMetric",
                    array: true,
                    relation: { opposite: "program" }
                },
                parameters: {
                    name: "parameters",
                    type: "ProgramParameter",
                    array: true,
                    relation: { opposite: "program" }
                },
                userPrograms: {
                    name: "userPrograms",
                    type: "UserProgram",
                    array: true,
                    relation: { opposite: "program" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" },
                designEventId: { type: "String" },
                legacyId: { type: "String" },
                handle_version: { handle: { type: "String" }, version: { type: "Int" } }
            }
        },
        Metric: {
            name: "Metric",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                shortName: {
                    name: "shortName",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(40) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                icon: {
                    name: "icon",
                    type: "String",
                    optional: true
                },
                category: {
                    name: "category",
                    type: "MetricCategory"
                },
                measure: {
                    name: "measure",
                    type: "Measure"
                },
                unitId: {
                    name: "unitId",
                    type: "String",
                    foreignKeyFor: [
                        "unit"
                    ] as readonly string[]
                },
                unit: {
                    name: "unit",
                    type: "Unit",
                    relation: { opposite: "metricsAsCanonical", name: "MetricCanonicalUnit", fields: ["unitId"], references: ["id"] }
                },
                unitUsId: {
                    name: "unitUsId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "unitUs"
                    ] as readonly string[]
                },
                unitUs: {
                    name: "unitUs",
                    type: "Unit",
                    optional: true,
                    relation: { opposite: "metricsAsUs", name: "MetricUsUnit", fields: ["unitUsId"], references: ["id"] }
                },
                chartType: {
                    name: "chartType",
                    type: "MetricChartType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("line") }] }] as readonly AttributeApplication[],
                    default: "line" as FieldDefault
                },
                decimals: {
                    name: "decimals",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(6) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                minValue: {
                    name: "minValue",
                    type: "Float",
                    optional: true
                },
                maxValue: {
                    name: "maxValue",
                    type: "Float",
                    optional: true
                },
                valueStep: {
                    name: "valueStep",
                    type: "Float",
                    optional: true
                },
                betterValues: {
                    name: "betterValues",
                    type: "MetricDirection",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("higher") }] }] as readonly AttributeApplication[],
                    default: "higher" as FieldDefault
                },
                goalLow: {
                    name: "goalLow",
                    type: "Float",
                    optional: true
                },
                goalMid: {
                    name: "goalMid",
                    type: "Float",
                    optional: true
                },
                baseRule: {
                    name: "baseRule",
                    type: "MetricBaseRule",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("last") }] }] as readonly AttributeApplication[],
                    default: "last" as FieldDefault
                },
                baseMetricId: {
                    name: "baseMetricId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "baseMetric"
                    ] as readonly string[]
                },
                baseMetric: {
                    name: "baseMetric",
                    type: "Metric",
                    optional: true,
                    relation: { opposite: "providerMetrics", name: "MetricBase", fields: ["baseMetricId"], references: ["id"], onDelete: "SetNull" }
                },
                providerMetrics: {
                    name: "providerMetrics",
                    type: "Metric",
                    array: true,
                    relation: { opposite: "baseMetric", name: "MetricBase" }
                },
                dependencies: {
                    name: "dependencies",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                calculation: {
                    name: "calculation",
                    type: "String",
                    optional: true
                },
                source: {
                    name: "source",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("manual") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(64) }] }] as readonly AttributeApplication[],
                    default: "manual" as FieldDefault
                },
                hiddenFromLibrary: {
                    name: "hiddenFromLibrary",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                scaleLabels: {
                    name: "scaleLabels",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                sourceInfo: {
                    name: "sourceInfo",
                    type: "Json",
                    optional: true
                },
                dashboardTimePeriod: {
                    name: "dashboardTimePeriod",
                    type: "DashboardTimePeriod",
                    optional: true
                },
                userMetrics: {
                    name: "userMetrics",
                    type: "UserMetric",
                    array: true,
                    relation: { opposite: "metric" }
                },
                linkedHabits: {
                    name: "linkedHabits",
                    type: "Habit",
                    array: true,
                    relation: { opposite: "metric" }
                },
                outcomePrograms: {
                    name: "outcomePrograms",
                    type: "Program",
                    array: true,
                    relation: { opposite: "outcomeMetric", name: "ProgramOutcomeMetric" }
                },
                programHabits: {
                    name: "programHabits",
                    type: "ProgramHabit",
                    array: true,
                    relation: { opposite: "metric" }
                },
                programMetrics: {
                    name: "programMetrics",
                    type: "ProgramMetric",
                    array: true,
                    relation: { opposite: "metric" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        Habit: {
            name: "Habit",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                allDay: {
                    name: "allDay",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                start: {
                    name: "start",
                    type: "String",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                end: {
                    name: "end",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                recurrence: {
                    name: "recurrence",
                    type: "HabitRecurrence",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("daily") }] }] as readonly AttributeApplication[],
                    default: "daily" as FieldDefault
                },
                recurIncrement: {
                    name: "recurIncrement",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(104) }, { name: "message", value: ExpressionUtils.literal("The maximum recurrence is 104") }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                recurDays: {
                    name: "recurDays",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("SU,MO,TU,WE,TH,FR,SA") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(0) }, { name: "max", value: ExpressionUtils.literal(21) }] }] as readonly AttributeApplication[],
                    default: "SU,MO,TU,WE,TH,FR,SA" as FieldDefault
                },
                timeBlock: {
                    name: "timeBlock",
                    type: "TimeBlock",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("morning") }] }] as readonly AttributeApplication[],
                    default: "morning" as FieldDefault
                },
                startTime: {
                    name: "startTime",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                effort: {
                    name: "effort",
                    type: "Effort",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("medium") }] }] as readonly AttributeApplication[],
                    default: "medium" as FieldDefault
                },
                duration: {
                    name: "duration",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("00:30:00") }] }, { name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: "00:30:00" as FieldDefault
                },
                graceDays: {
                    name: "graceDays",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(30) }, { name: "message", value: ExpressionUtils.literal("The maximum grace period is 30 days") }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                reminders: {
                    name: "reminders",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(4) }, { name: "message", value: ExpressionUtils.literal("Reminders must be between 0 (none) and 4 (frequent)") }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                essential: {
                    name: "essential",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                programId: {
                    name: "programId",
                    type: "String",
                    optional: true
                },
                programUserId: {
                    name: "programUserId",
                    type: "String",
                    optional: true
                },
                originalHabitId: {
                    name: "originalHabitId",
                    type: "String",
                    optional: true
                },
                programStartDay: {
                    name: "programStartDay",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(3650) }, { name: "message", value: ExpressionUtils.literal("The habit must start within 10 years") }] }] as readonly AttributeApplication[]
                },
                programEndType: {
                    name: "programEndType",
                    type: "HabitEndType",
                    optional: true
                },
                lastEventStart: {
                    name: "lastEventStart",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                metricId: {
                    name: "metricId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "metric"
                    ] as readonly string[]
                },
                metric: {
                    name: "metric",
                    type: "Metric",
                    optional: true,
                    relation: { opposite: "linkedHabits", fields: ["metricId"], references: ["id"], onDelete: "SetNull" }
                },
                autoDoneValue: {
                    name: "autoDoneValue",
                    type: "Float",
                    optional: true
                },
                autoPartialValue: {
                    name: "autoPartialValue",
                    type: "Float",
                    optional: true
                },
                event: {
                    name: "event",
                    type: "Event",
                    array: true,
                    relation: { opposite: "habit" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        Event: {
            name: "Event",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                habitId: {
                    name: "habitId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "habit"
                    ] as readonly string[]
                },
                habit: {
                    name: "habit",
                    type: "Habit",
                    optional: true,
                    relation: { opposite: "event", fields: ["habitId"], references: ["id"], onDelete: "Cascade" }
                },
                notes: {
                    name: "notes",
                    type: "String",
                    optional: true
                },
                allDay: {
                    name: "allDay",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                start: {
                    name: "start",
                    type: "String",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                end: {
                    name: "end",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                startTime: {
                    name: "startTime",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                duration: {
                    name: "duration",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                remindAtUtc: {
                    name: "remindAtUtc",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@datetime" }] as readonly AttributeApplication[]
                },
                remindersSent: {
                    name: "remindersSent",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                completed: {
                    name: "completed",
                    type: "HabitCompletion",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("empty") }] }] as readonly AttributeApplication[],
                    default: "empty" as FieldDefault
                },
                completedBy: {
                    name: "completedBy",
                    type: "HabitCompletedBy",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        Unit: {
            name: "Unit",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                measure: {
                    name: "measure",
                    type: "Measure"
                },
                plural: {
                    name: "plural",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(60) }] }] as readonly AttributeApplication[]
                },
                abbrev: {
                    name: "abbrev",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(20) }] }] as readonly AttributeApplication[]
                },
                suffix: {
                    name: "suffix",
                    type: "String",
                    optional: true
                },
                system: {
                    name: "system",
                    type: "UnitSystem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("none") }] }] as readonly AttributeApplication[],
                    default: "none" as FieldDefault
                },
                toAnchor: {
                    name: "toAnchor",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                toAnchorOffset: {
                    name: "toAnchorOffset",
                    type: "Float",
                    optional: true
                },
                shortSlug: {
                    name: "shortSlug",
                    type: "String",
                    optional: true
                },
                prefix: {
                    name: "prefix",
                    type: "String",
                    optional: true
                },
                isAnchor: {
                    name: "isAnchor",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                anchorRatio: {
                    name: "anchorRatio",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                metricsAsCanonical: {
                    name: "metricsAsCanonical",
                    type: "Metric",
                    array: true,
                    relation: { opposite: "unit", name: "MetricCanonicalUnit" }
                },
                metricsAsUs: {
                    name: "metricsAsUs",
                    type: "Metric",
                    array: true,
                    relation: { opposite: "unitUs", name: "MetricUsUnit" }
                },
                userMetrics: {
                    name: "userMetrics",
                    type: "UserMetric",
                    array: true,
                    relation: { opposite: "unit" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" },
                measure_shortSlug: { measure: { type: "Measure" }, shortSlug: { type: "String" } }
            }
        },
        UserMetric: {
            name: "UserMetric",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                metricId: {
                    name: "metricId",
                    type: "String",
                    foreignKeyFor: [
                        "metric"
                    ] as readonly string[]
                },
                metric: {
                    name: "metric",
                    type: "Metric",
                    relation: { opposite: "userMetrics", fields: ["metricId"], references: ["id"], onDelete: "Cascade" }
                },
                unitId: {
                    name: "unitId",
                    type: "String",
                    foreignKeyFor: [
                        "unit"
                    ] as readonly string[]
                },
                unit: {
                    name: "unit",
                    type: "Unit",
                    relation: { opposite: "userMetrics", fields: ["unitId"], references: ["id"] }
                },
                ownerMetricKey: {
                    name: "ownerMetricKey",
                    type: "String",
                    unique: true
                },
                decimals: {
                    name: "decimals",
                    type: "Int",
                    optional: true
                },
                minValue: {
                    name: "minValue",
                    type: "Float",
                    optional: true
                },
                maxValue: {
                    name: "maxValue",
                    type: "Float",
                    optional: true
                },
                valueStep: {
                    name: "valueStep",
                    type: "Float",
                    optional: true
                },
                betterValues: {
                    name: "betterValues",
                    type: "MetricDirection",
                    optional: true
                },
                goalLow: {
                    name: "goalLow",
                    type: "Float",
                    optional: true
                },
                goalMid: {
                    name: "goalMid",
                    type: "Float",
                    optional: true
                },
                baseline: {
                    name: "baseline",
                    type: "Float",
                    optional: true
                },
                targetValue: {
                    name: "targetValue",
                    type: "Float",
                    optional: true
                },
                targetDate: {
                    name: "targetDate",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                startDate: {
                    name: "startDate",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                baseRule: {
                    name: "baseRule",
                    type: "MetricBaseRule",
                    optional: true
                },
                syncedAt: {
                    name: "syncedAt",
                    type: "DateTime",
                    optional: true
                },
                calculationError: {
                    name: "calculationError",
                    type: "String",
                    optional: true
                },
                values: {
                    name: "values",
                    type: "MetricValue",
                    array: true,
                    relation: { opposite: "userMetric" }
                },
                syncAudits: {
                    name: "syncAudits",
                    type: "MetricSyncAudit",
                    array: true,
                    relation: { opposite: "userMetric" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                ownerMetricKey: { type: "String" }
            }
        },
        MetricValue: {
            name: "MetricValue",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                userMetricId: {
                    name: "userMetricId",
                    type: "String",
                    foreignKeyFor: [
                        "userMetric"
                    ] as readonly string[]
                },
                userMetric: {
                    name: "userMetric",
                    type: "UserMetric",
                    relation: { opposite: "values", fields: ["userMetricId"], references: ["id"], onDelete: "Cascade" }
                },
                measuredAt: {
                    name: "measuredAt",
                    type: "DateTime"
                },
                localDay: {
                    name: "localDay",
                    type: "String",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                value: {
                    name: "value",
                    type: "Float"
                },
                source: {
                    name: "source",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(64) }] }] as readonly AttributeApplication[]
                },
                sourceId: {
                    name: "sourceId",
                    type: "String",
                    optional: true
                },
                origin: {
                    name: "origin",
                    type: "String",
                    optional: true
                },
                originName: {
                    name: "originName",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                userMetricId_localDay_source: { userMetricId: { type: "String" }, localDay: { type: "String" }, source: { type: "String" } }
            }
        },
        MetricSyncAudit: {
            name: "MetricSyncAudit",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                userMetricId: {
                    name: "userMetricId",
                    type: "String",
                    foreignKeyFor: [
                        "userMetric"
                    ] as readonly string[]
                },
                userMetric: {
                    name: "userMetric",
                    type: "UserMetric",
                    relation: { opposite: "syncAudits", fields: ["userMetricId"], references: ["id"], onDelete: "Cascade" }
                },
                source: {
                    name: "source",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(64) }] }] as readonly AttributeApplication[]
                },
                created: {
                    name: "created",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                updated: {
                    name: "updated",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                recomputed: {
                    name: "recomputed",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(1024) }] }] as readonly AttributeApplication[]
                },
                syncedAt: {
                    name: "syncedAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ProgramHabit: {
            name: "ProgramHabit",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                programId: {
                    name: "programId",
                    type: "String",
                    foreignKeyFor: [
                        "program"
                    ] as readonly string[]
                },
                program: {
                    name: "program",
                    type: "Program",
                    relation: { opposite: "habits", fields: ["programId"], references: ["id"], onDelete: "Cascade" }
                },
                phaseId: {
                    name: "phaseId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "phase"
                    ] as readonly string[]
                },
                phase: {
                    name: "phase",
                    type: "ProgramPhase",
                    optional: true,
                    relation: { opposite: "habits", fields: ["phaseId"], references: ["id"], onDelete: "Cascade" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String"
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                allDay: {
                    name: "allDay",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                recurrence: {
                    name: "recurrence",
                    type: "HabitRecurrence",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("daily") }] }] as readonly AttributeApplication[],
                    default: "daily" as FieldDefault
                },
                recurIncrement: {
                    name: "recurIncrement",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(104) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                recurDays: {
                    name: "recurDays",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("SU,MO,TU,WE,TH,FR,SA") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(0) }, { name: "max", value: ExpressionUtils.literal(21) }] }] as readonly AttributeApplication[],
                    default: "SU,MO,TU,WE,TH,FR,SA" as FieldDefault
                },
                timeBlock: {
                    name: "timeBlock",
                    type: "TimeBlock",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("morning") }] }] as readonly AttributeApplication[],
                    default: "morning" as FieldDefault
                },
                startTime: {
                    name: "startTime",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                effort: {
                    name: "effort",
                    type: "Effort",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("medium") }] }] as readonly AttributeApplication[],
                    default: "medium" as FieldDefault
                },
                duration: {
                    name: "duration",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("00:30:00") }] }, { name: "@time", args: [{ name: "precision", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: "00:30:00" as FieldDefault
                },
                graceDays: {
                    name: "graceDays",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(30) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                reminders: {
                    name: "reminders",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(4) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                essential: {
                    name: "essential",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                metricId: {
                    name: "metricId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "metric"
                    ] as readonly string[]
                },
                metric: {
                    name: "metric",
                    type: "Metric",
                    optional: true,
                    relation: { opposite: "programHabits", fields: ["metricId"], references: ["id"], onDelete: "SetNull" }
                },
                autoDoneValue: {
                    name: "autoDoneValue",
                    type: "Float",
                    optional: true
                },
                autoPartialValue: {
                    name: "autoPartialValue",
                    type: "Float",
                    optional: true
                },
                startDay: {
                    name: "startDay",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(3650) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                endType: {
                    name: "endType",
                    type: "HabitEndType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("phase") }] }] as readonly AttributeApplication[],
                    default: "phase" as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ProgramPhase: {
            name: "ProgramPhase",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                programId: {
                    name: "programId",
                    type: "String",
                    foreignKeyFor: [
                        "program"
                    ] as readonly string[]
                },
                program: {
                    name: "program",
                    type: "Program",
                    relation: { opposite: "phases", fields: ["programId"], references: ["id"], onDelete: "Cascade" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                epigraph: {
                    name: "epigraph",
                    type: "String",
                    optional: true
                },
                days: {
                    name: "days",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(28) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 28 as FieldDefault
                },
                contentSecs: {
                    name: "contentSecs",
                    type: "Int",
                    optional: true
                },
                lessons: {
                    name: "lessons",
                    type: "ProgramLesson",
                    array: true,
                    relation: { opposite: "phase" }
                },
                habits: {
                    name: "habits",
                    type: "ProgramHabit",
                    array: true,
                    relation: { opposite: "phase" }
                },
                metrics: {
                    name: "metrics",
                    type: "ProgramMetric",
                    array: true,
                    relation: { opposite: "phase" }
                },
                userProgramPhases: {
                    name: "userProgramPhases",
                    type: "UserProgramPhase",
                    array: true,
                    relation: { opposite: "phase" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ProgramLesson: {
            name: "ProgramLesson",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                programId: {
                    name: "programId",
                    type: "String",
                    foreignKeyFor: [
                        "program"
                    ] as readonly string[]
                },
                program: {
                    name: "program",
                    type: "Program",
                    relation: { opposite: "lessons", fields: ["programId"], references: ["id"], onDelete: "Cascade" }
                },
                phaseId: {
                    name: "phaseId",
                    type: "String",
                    foreignKeyFor: [
                        "phase"
                    ] as readonly string[]
                },
                phase: {
                    name: "phase",
                    type: "ProgramPhase",
                    relation: { opposite: "lessons", fields: ["phaseId"], references: ["id"], onDelete: "Cascade" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                epigraph: {
                    name: "epigraph",
                    type: "String",
                    optional: true
                },
                dayOffset: {
                    name: "dayOffset",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                unlockRule: {
                    name: "unlockRule",
                    type: "ProgramLessonUnlock",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("sequential") }] }] as readonly AttributeApplication[],
                    default: "sequential" as FieldDefault
                },
                quizId: {
                    name: "quizId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "quiz"
                    ] as readonly string[]
                },
                quiz: {
                    name: "quiz",
                    type: "Quiz",
                    optional: true,
                    relation: { opposite: "programLessons", fields: ["quizId"], references: ["id"], onDelete: "SetNull" }
                },
                questionsPerAttempt: {
                    name: "questionsPerAttempt",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[]
                },
                passPercent: {
                    name: "passPercent",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(70) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[],
                    default: 70 as FieldDefault
                },
                maxQuizAttempts: {
                    name: "maxQuizAttempts",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(3) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 3 as FieldDefault
                },
                contentSecs: {
                    name: "contentSecs",
                    type: "Int",
                    optional: true
                },
                steps: {
                    name: "steps",
                    type: "ProgramStep",
                    array: true,
                    relation: { opposite: "lesson" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Quiz: {
            name: "Quiz",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                group: {
                    name: "group",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(10) }] }] as readonly AttributeApplication[]
                },
                handle: {
                    name: "handle",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                date: {
                    name: "date",
                    type: "String",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                image: {
                    name: "image",
                    type: "String",
                    optional: true
                },
                icon: {
                    name: "icon",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String",
                    fullText: true
                },
                instructions: {
                    name: "instructions",
                    type: "String",
                    fullText: true
                },
                quizArchivedAt: {
                    name: "quizArchivedAt",
                    type: "DateTime",
                    optional: true
                },
                maxScore: {
                    name: "maxScore",
                    type: "Int",
                    optional: true
                },
                randomizeAnswers: {
                    name: "randomizeAnswers",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                analysisBotGroup: {
                    name: "analysisBotGroup",
                    type: "String",
                    optional: true
                },
                analysisBotHandle: {
                    name: "analysisBotHandle",
                    type: "String",
                    optional: true
                },
                analysisSchema: {
                    name: "analysisSchema",
                    type: "String",
                    optional: true
                },
                sections: {
                    name: "sections",
                    type: "QuizSection",
                    array: true,
                    relation: { opposite: "quiz" }
                },
                questions: {
                    name: "questions",
                    type: "QuizQuestion",
                    array: true,
                    relation: { opposite: "quiz" }
                },
                results: {
                    name: "results",
                    type: "QuizResult",
                    array: true,
                    relation: { opposite: "quiz" }
                },
                programLessons: {
                    name: "programLessons",
                    type: "ProgramLesson",
                    array: true,
                    relation: { opposite: "quiz" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" },
                handle_version: { handle: { type: "String" }, version: { type: "Int" } }
            }
        },
        QuizSection: {
            name: "QuizSection",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                handle: {
                    name: "handle",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(32) }] }] as readonly AttributeApplication[]
                },
                ord: {
                    name: "ord",
                    type: "Int"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                quizId: {
                    name: "quizId",
                    type: "String",
                    foreignKeyFor: [
                        "quiz"
                    ] as readonly string[]
                },
                quiz: {
                    name: "quiz",
                    type: "Quiz",
                    relation: { opposite: "sections", fields: ["quizId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                quizId_handle: { quizId: { type: "String" }, handle: { type: "String" } }
            }
        },
        QuizQuestion: {
            name: "QuizQuestion",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                handle: {
                    name: "handle",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(32) }] }] as readonly AttributeApplication[]
                },
                sectionHandle: {
                    name: "sectionHandle",
                    type: "String"
                },
                ord: {
                    name: "ord",
                    type: "Int"
                },
                type: {
                    name: "type",
                    type: "QuizQuestionType"
                },
                question: {
                    name: "question",
                    type: "String",
                    fullText: true
                },
                maxScore: {
                    name: "maxScore",
                    type: "Int",
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(10) }] }] as readonly AttributeApplication[]
                },
                weight: {
                    name: "weight",
                    type: "Int",
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[]
                },
                answers: {
                    name: "answers",
                    type: "QuizAnswer",
                    array: true
                },
                filterQuestion: {
                    name: "filterQuestion",
                    type: "String",
                    optional: true
                },
                filterValues: {
                    name: "filterValues",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                autoFill: {
                    name: "autoFill",
                    type: "String",
                    optional: true
                },
                evalHint: {
                    name: "evalHint",
                    type: "String",
                    optional: true
                },
                quizId: {
                    name: "quizId",
                    type: "String",
                    foreignKeyFor: [
                        "quiz"
                    ] as readonly string[]
                },
                quiz: {
                    name: "quiz",
                    type: "Quiz",
                    relation: { opposite: "questions", fields: ["quizId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                quizId_handle: { quizId: { type: "String" }, handle: { type: "String" } }
            }
        },
        QuizResult: {
            name: "QuizResult",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                quizHandle: {
                    name: "quizHandle",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "quiz"
                    ] as readonly string[]
                },
                questionHandles: {
                    name: "questionHandles",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                quizVersion: {
                    name: "quizVersion",
                    type: "Int",
                    foreignKeyFor: [
                        "quiz"
                    ] as readonly string[]
                },
                state: {
                    name: "state",
                    type: "QuizResultState",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("PENDING") }] }] as readonly AttributeApplication[],
                    default: "PENDING" as FieldDefault
                },
                completedOn: {
                    name: "completedOn",
                    type: "DateTime",
                    optional: true
                },
                durationSecs: {
                    name: "durationSecs",
                    type: "Int",
                    optional: true
                },
                executionId: {
                    name: "executionId",
                    type: "String",
                    optional: true
                },
                totalScore: {
                    name: "totalScore",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                maxScore: {
                    name: "maxScore",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                gradePercent: {
                    name: "gradePercent",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                bracket: {
                    name: "bracket",
                    type: "QuizResultBracket",
                    optional: true
                },
                analysis: {
                    name: "analysis",
                    type: "Json",
                    optional: true
                },
                analysisSchema: {
                    name: "analysisSchema",
                    type: "String",
                    optional: true
                },
                evaluation: {
                    name: "evaluation",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                presentedAt: {
                    name: "presentedAt",
                    type: "DateTime",
                    optional: true
                },
                quiz: {
                    name: "quiz",
                    type: "Quiz",
                    relation: { opposite: "results", fields: ["quizHandle", "quizVersion"], references: ["handle", "version"], onDelete: "Cascade" }
                },
                questionResults: {
                    name: "questionResults",
                    type: "QuizQuestionResult",
                    array: true,
                    relation: { opposite: "quizResult" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        QuizQuestionResult: {
            name: "QuizQuestionResult",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                questionHandle: {
                    name: "questionHandle",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(32) }] }] as readonly AttributeApplication[]
                },
                questionType: {
                    name: "questionType",
                    type: "QuizQuestionType"
                },
                skipped: {
                    name: "skipped",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                selectedLabel: {
                    name: "selectedLabel",
                    type: "String",
                    optional: true
                },
                selectedValue: {
                    name: "selectedValue",
                    type: "String",
                    optional: true
                },
                score: {
                    name: "score",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                justification: {
                    name: "justification",
                    type: "String",
                    optional: true
                },
                answerOrder: {
                    name: "answerOrder",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                quizResultId: {
                    name: "quizResultId",
                    type: "String",
                    foreignKeyFor: [
                        "quizResult"
                    ] as readonly string[]
                },
                quizResult: {
                    name: "quizResult",
                    type: "QuizResult",
                    relation: { opposite: "questionResults", fields: ["quizResultId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ProgramMetric: {
            name: "ProgramMetric",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                programId: {
                    name: "programId",
                    type: "String",
                    foreignKeyFor: [
                        "program"
                    ] as readonly string[]
                },
                program: {
                    name: "program",
                    type: "Program",
                    relation: { opposite: "metrics", fields: ["programId"], references: ["id"], onDelete: "Cascade" }
                },
                phaseId: {
                    name: "phaseId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "phase"
                    ] as readonly string[]
                },
                phase: {
                    name: "phase",
                    type: "ProgramPhase",
                    optional: true,
                    relation: { opposite: "metrics", fields: ["phaseId"], references: ["id"], onDelete: "Cascade" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                metricId: {
                    name: "metricId",
                    type: "String",
                    foreignKeyFor: [
                        "metric"
                    ] as readonly string[]
                },
                metric: {
                    name: "metric",
                    type: "Metric",
                    relation: { opposite: "programMetrics", fields: ["metricId"], references: ["id"], onDelete: "Cascade" }
                },
                role: {
                    name: "role",
                    type: "ProgramMetricRole",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("behavior") }] }] as readonly AttributeApplication[],
                    default: "behavior" as FieldDefault
                },
                goalLow: {
                    name: "goalLow",
                    type: "Float",
                    optional: true
                },
                goalMid: {
                    name: "goalMid",
                    type: "Float",
                    optional: true
                },
                targetValue: {
                    name: "targetValue",
                    type: "Float",
                    optional: true
                },
                targetIsDelta: {
                    name: "targetIsDelta",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        UserProgramPhase: {
            name: "UserProgramPhase",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                userProgramId: {
                    name: "userProgramId",
                    type: "String",
                    foreignKeyFor: [
                        "userProgram"
                    ] as readonly string[]
                },
                userProgram: {
                    name: "userProgram",
                    type: "UserProgram",
                    relation: { opposite: "phases", fields: ["userProgramId"], references: ["id"], onDelete: "Cascade" }
                },
                phaseId: {
                    name: "phaseId",
                    type: "String",
                    foreignKeyFor: [
                        "phase"
                    ] as readonly string[]
                },
                phase: {
                    name: "phase",
                    type: "ProgramPhase",
                    relation: { opposite: "userProgramPhases", fields: ["phaseId"], references: ["id"], onDelete: "Restrict" }
                },
                startDate: {
                    name: "startDate",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                endDate: {
                    name: "endDate",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                userMetricIds: {
                    name: "userMetricIds",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                userHabitIds: {
                    name: "userHabitIds",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                userProgramId_phaseId: { userProgramId: { type: "String" }, phaseId: { type: "String" } }
            }
        },
        UserProgram: {
            name: "UserProgram",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                programId: {
                    name: "programId",
                    type: "String",
                    foreignKeyFor: [
                        "program"
                    ] as readonly string[]
                },
                program: {
                    name: "program",
                    type: "Program",
                    relation: { opposite: "userPrograms", fields: ["programId"], references: ["id"], onDelete: "Restrict" }
                },
                runNumber: {
                    name: "runNumber",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                ownerProgramRunKey: {
                    name: "ownerProgramRunKey",
                    type: "String",
                    unique: true
                },
                status: {
                    name: "status",
                    type: "UserProgramStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("current") }] }] as readonly AttributeApplication[],
                    default: "current" as FieldDefault
                },
                startDate: {
                    name: "startDate",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                endDate: {
                    name: "endDate",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                pausedAt: {
                    name: "pausedAt",
                    type: "DateTime",
                    optional: true
                },
                pausedDays: {
                    name: "pausedDays",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                parameterValues: {
                    name: "parameterValues",
                    type: "Json",
                    optional: true
                },
                learningPercent: {
                    name: "learningPercent",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                practicePercent: {
                    name: "practicePercent",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                resultsPercent: {
                    name: "resultsPercent",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                progressPercent: {
                    name: "progressPercent",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                currentStepId: {
                    name: "currentStepId",
                    type: "String",
                    optional: true
                },
                postMortemConvoId: {
                    name: "postMortemConvoId",
                    type: "String",
                    optional: true
                },
                completedAt: {
                    name: "completedAt",
                    type: "DateTime",
                    optional: true
                },
                abandonedAt: {
                    name: "abandonedAt",
                    type: "DateTime",
                    optional: true
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true
                },
                phases: {
                    name: "phases",
                    type: "UserProgramPhase",
                    array: true,
                    relation: { opposite: "userProgram" }
                },
                nodes: {
                    name: "nodes",
                    type: "UserProgramNode",
                    array: true,
                    relation: { opposite: "userProgram" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                ownerProgramRunKey: { type: "String" }
            }
        },
        UserProgramNode: {
            name: "UserProgramNode",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                userProgramId: {
                    name: "userProgramId",
                    type: "String",
                    foreignKeyFor: [
                        "userProgram"
                    ] as readonly string[]
                },
                userProgram: {
                    name: "userProgram",
                    type: "UserProgram",
                    relation: { opposite: "nodes", fields: ["userProgramId"], references: ["id"], onDelete: "Cascade" }
                },
                nodeType: {
                    name: "nodeType",
                    type: "UserProgramNodeType"
                },
                nodeId: {
                    name: "nodeId",
                    type: "String"
                },
                state: {
                    name: "state",
                    type: "UserProgramNodeState",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("future") }] }] as readonly AttributeApplication[],
                    default: "future" as FieldDefault
                },
                passed: {
                    name: "passed",
                    type: "Boolean",
                    optional: true
                },
                progress: {
                    name: "progress",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                completedAt: {
                    name: "completedAt",
                    type: "DateTime",
                    optional: true
                },
                quizResultId: {
                    name: "quizResultId",
                    type: "String",
                    optional: true
                },
                quizAttempts: {
                    name: "quizAttempts",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                convoId: {
                    name: "convoId",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                userProgramId_nodeId: { userProgramId: { type: "String" }, nodeId: { type: "String" } }
            }
        },
        ProgramParameter: {
            name: "ProgramParameter",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                programId: {
                    name: "programId",
                    type: "String",
                    foreignKeyFor: [
                        "program"
                    ] as readonly string[]
                },
                program: {
                    name: "program",
                    type: "Program",
                    relation: { opposite: "parameters", fields: ["programId"], references: ["id"], onDelete: "Cascade" }
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                key: {
                    name: "key",
                    type: "String",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z][a-zA-Z0-9]*$") }] }] as readonly AttributeApplication[]
                },
                question: {
                    name: "question",
                    type: "String",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(300) }] }] as readonly AttributeApplication[]
                },
                type: {
                    name: "type",
                    type: "ProgramParameterType"
                },
                options: {
                    name: "options",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                defaultValue: {
                    name: "defaultValue",
                    type: "String",
                    optional: true
                },
                profileField: {
                    name: "profileField",
                    type: "String",
                    optional: true
                },
                unit: {
                    name: "unit",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                programId_key: { programId: { type: "String" }, key: { type: "String" } }
            }
        },
        Author: {
            name: "Author",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                images: {
                    name: "images",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                url: {
                    name: "url",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url", args: [{ name: "message", value: ExpressionUtils.literal("Please enter a valid URL") }] }] as readonly AttributeApplication[]
                },
                bio: {
                    name: "bio",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(100) }, { name: "max", value: ExpressionUtils.literal(2000) }, { name: "message", value: ExpressionUtils.literal("Bio must be between 100 and 2000 characters") }] }] as readonly AttributeApplication[]
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(50) }, { name: "max", value: ExpressionUtils.literal(250) }, { name: "message", value: ExpressionUtils.literal("Summary must be between 50 and 250 characters") }] }] as readonly AttributeApplication[]
                },
                resAuthors: {
                    name: "resAuthors",
                    type: "ResAuthor",
                    array: true,
                    relation: { opposite: "author" }
                },
                socialAccounts: {
                    name: "socialAccounts",
                    type: "SocialAccount",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                sources: {
                    name: "sources",
                    type: "Source",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                name_version: { name: { type: "String" }, version: { type: "Int" } }
            }
        },
        ResAuthor: {
            name: "ResAuthor",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                resourceId: {
                    name: "resourceId",
                    type: "String",
                    foreignKeyFor: [
                        "resource"
                    ] as readonly string[]
                },
                resource: {
                    name: "resource",
                    type: "ResourceItem",
                    relation: { opposite: "resAuthors", fields: ["resourceId"], references: ["id"], onDelete: "Cascade" }
                },
                authorId: {
                    name: "authorId",
                    type: "String",
                    foreignKeyFor: [
                        "author"
                    ] as readonly string[]
                },
                author: {
                    name: "author",
                    type: "Author",
                    relation: { opposite: "resAuthors", fields: ["authorId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                resourceId_authorId: { resourceId: { type: "String" }, authorId: { type: "String" } }
            }
        },
        ResourceLink: {
            name: "ResourceLink",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                platform: {
                    name: "platform",
                    type: "ResourcePlatformId"
                },
                format: {
                    name: "format",
                    type: "ResourceFormat",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("other") }] }] as readonly AttributeApplication[],
                    default: "other" as FieldDefault
                },
                dataUrl: {
                    name: "dataUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                url: {
                    name: "url",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                externalId: {
                    name: "externalId",
                    type: "String",
                    optional: true,
                    fuzzy: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                durationSeconds: {
                    name: "durationSeconds",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                score: {
                    name: "score",
                    type: "Float",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                price: {
                    name: "price",
                    type: "Float",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                priceType: {
                    name: "priceType",
                    type: "PriceType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("not_available") }] }] as readonly AttributeApplication[],
                    default: "not_available" as FieldDefault
                },
                currency: {
                    name: "currency",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USD") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(3) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[A-Z]{3}$") }] }] as readonly AttributeApplication[],
                    default: "USD" as FieldDefault
                },
                resourceItemId: {
                    name: "resourceItemId",
                    type: "String",
                    foreignKeyFor: [
                        "resourceItem"
                    ] as readonly string[]
                },
                resourceItem: {
                    name: "resourceItem",
                    type: "ResourceItem",
                    relation: { opposite: "resourceLinks", fields: ["resourceItemId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                platform_externalId_version: { platform: { type: "ResourcePlatformId" }, externalId: { type: "String" }, version: { type: "Int" } }
            }
        },
        Transcript: {
            name: "Transcript",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                text: {
                    name: "text",
                    type: "String"
                },
                compressed: {
                    name: "compressed",
                    type: "String",
                    optional: true
                },
                json: {
                    name: "json",
                    type: "Json",
                    optional: true
                },
                transcribedBy: {
                    name: "transcribedBy",
                    type: "String"
                },
                jobSeconds: {
                    name: "jobSeconds",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cost: {
                    name: "cost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                resourceItemId: {
                    name: "resourceItemId",
                    type: "String",
                    foreignKeyFor: [
                        "resourceItem"
                    ] as readonly string[]
                },
                resourceItem: {
                    name: "resourceItem",
                    type: "ResourceItem",
                    relation: { opposite: "transcripts", fields: ["resourceItemId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ToolSet: {
            name: "ToolSet",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                entries: {
                    name: "entries",
                    type: "ToolSetEntry",
                    array: true,
                    relation: { opposite: "toolSet" }
                },
                bots: {
                    name: "bots",
                    type: "Bot",
                    array: true,
                    relation: { opposite: "toolSet" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        ToolSetEntry: {
            name: "ToolSetEntry",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                toolSetId: {
                    name: "toolSetId",
                    type: "String",
                    foreignKeyFor: [
                        "toolSet"
                    ] as readonly string[]
                },
                kind: {
                    name: "kind",
                    type: "ToolSetEntryKind"
                },
                key: {
                    name: "key",
                    type: "String"
                },
                disabledTools: {
                    name: "disabledTools",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                deferredTools: {
                    name: "deferredTools",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                deferred: {
                    name: "deferred",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                toolSet: {
                    name: "toolSet",
                    type: "ToolSet",
                    relation: { opposite: "entries", fields: ["toolSetId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                toolSetId_kind_key: { toolSetId: { type: "String" }, kind: { type: "ToolSetEntryKind" }, key: { type: "String" } }
            }
        },
        AiStep: {
            name: "AiStep",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                type: {
                    name: "type",
                    type: "ConvoType"
                },
                convoId: {
                    name: "convoId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "convo"
                    ] as readonly string[]
                },
                convo: {
                    name: "convo",
                    type: "Convo",
                    optional: true,
                    relation: { opposite: "aiSteps", fields: ["convoId"], references: ["id"], onDelete: "SetNull" }
                },
                aiMessageId: {
                    name: "aiMessageId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "aiMessage"
                    ] as readonly string[]
                },
                aiMessage: {
                    name: "aiMessage",
                    type: "AiMessage",
                    optional: true,
                    relation: { opposite: "aiSteps", fields: ["aiMessageId"], references: ["id"], onDelete: "SetNull" }
                },
                executionId: {
                    name: "executionId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "execution"
                    ] as readonly string[]
                },
                execution: {
                    name: "execution",
                    type: "Execution",
                    optional: true,
                    relation: { opposite: "aiSteps", fields: ["executionId"], references: ["id"], onDelete: "SetNull" }
                },
                botId: {
                    name: "botId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "bot"
                    ] as readonly string[]
                },
                bot: {
                    name: "bot",
                    type: "Bot",
                    optional: true,
                    relation: { opposite: "aiSteps", fields: ["botId"], references: ["id"], onDelete: "SetNull" }
                },
                ord: {
                    name: "ord",
                    type: "Int"
                },
                integration: {
                    name: "integration",
                    type: "String"
                },
                modelName: {
                    name: "modelName",
                    type: "String"
                },
                serviceTier: {
                    name: "serviceTier",
                    type: "ServiceTier"
                },
                subscription: {
                    name: "subscription",
                    type: "String",
                    optional: true
                },
                inputTokens: {
                    name: "inputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cachedInputTokens: {
                    name: "cachedInputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cacheWriteTokens: {
                    name: "cacheWriteTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                audioInputTokens: {
                    name: "audioInputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                audioInputSeconds: {
                    name: "audioInputSeconds",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                outputTokens: {
                    name: "outputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                reasoningTokens: {
                    name: "reasoningTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                inMegaTokCost: {
                    name: "inMegaTokCost",
                    type: "Float",
                    optional: true
                },
                cachedMegaTokCost: {
                    name: "cachedMegaTokCost",
                    type: "Float",
                    optional: true
                },
                cacheWriteMegaTokCost: {
                    name: "cacheWriteMegaTokCost",
                    type: "Float",
                    optional: true
                },
                outMegaTokCost: {
                    name: "outMegaTokCost",
                    type: "Float",
                    optional: true
                },
                audioInMegaTokCost: {
                    name: "audioInMegaTokCost",
                    type: "Float",
                    optional: true
                },
                audioInMinuteCost: {
                    name: "audioInMinuteCost",
                    type: "Float",
                    optional: true
                },
                minPromptTokens: {
                    name: "minPromptTokens",
                    type: "Int",
                    optional: true
                },
                inputCost: {
                    name: "inputCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cachedInputCost: {
                    name: "cachedInputCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cacheWriteCost: {
                    name: "cacheWriteCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                audioCost: {
                    name: "audioCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                outputCost: {
                    name: "outputCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                costSource: {
                    name: "costSource",
                    type: "AiStepCostSource"
                },
                priceFallback: {
                    name: "priceFallback",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                finishReason: {
                    name: "finishReason",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Execution: {
            name: "Execution",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                jobSlug: {
                    name: "jobSlug",
                    type: "String",
                    fuzzy: true
                },
                appId: {
                    name: "appId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("uvilo-ai") }] }] as readonly AttributeApplication[],
                    default: "uvilo-ai" as FieldDefault
                },
                loggingLevel: {
                    name: "loggingLevel",
                    type: "SeverityLevel",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("info") }] }] as readonly AttributeApplication[],
                    default: "info" as FieldDefault
                },
                state: {
                    name: "state",
                    type: "RunState",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("pending") }] }] as readonly AttributeApplication[],
                    default: "pending" as FieldDefault
                },
                message: {
                    name: "message",
                    type: "String",
                    fullText: true
                },
                tokenCount: {
                    name: "tokenCount",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                totalCost: {
                    name: "totalCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                stopRequested: {
                    name: "stopRequested",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                signal: {
                    name: "signal",
                    type: "ExecutionSignal",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "DateTime",
                    optional: true
                },
                durationMs: {
                    name: "durationMs",
                    type: "Int",
                    optional: true
                },
                noopCount: {
                    name: "noopCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                result: {
                    name: "result",
                    type: "Json",
                    optional: true
                },
                logs: {
                    name: "logs",
                    type: "ExecutionLog",
                    array: true,
                    relation: { opposite: "execution" }
                },
                aiSteps: {
                    name: "aiSteps",
                    type: "AiStep",
                    array: true,
                    relation: { opposite: "execution" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ExecutionLog: {
            name: "ExecutionLog",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime"
                },
                executionId: {
                    name: "executionId",
                    type: "String",
                    foreignKeyFor: [
                        "execution"
                    ] as readonly string[]
                },
                execution: {
                    name: "execution",
                    type: "Execution",
                    relation: { opposite: "logs", fields: ["executionId"], references: ["id"], onDelete: "Cascade" }
                },
                level: {
                    name: "level",
                    type: "SeverityLevel"
                },
                message: {
                    name: "message",
                    type: "String"
                },
                details: {
                    name: "details",
                    type: "Json",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        AiMessage: {
            name: "AiMessage",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                role: {
                    name: "role",
                    type: "AiMessageRole",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("assistant") }] }] as readonly AttributeApplication[],
                    default: "assistant" as FieldDefault
                },
                parts: {
                    name: "parts",
                    type: "Json"
                },
                stepTokens: {
                    name: "stepTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                inputTokens: {
                    name: "inputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                outputTokens: {
                    name: "outputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                reasoningTokens: {
                    name: "reasoningTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cachedInputTokens: {
                    name: "cachedInputTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                cacheWriteTokens: {
                    name: "cacheWriteTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                audioInputSeconds: {
                    name: "audioInputSeconds",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                inTotalCost: {
                    name: "inTotalCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                outTotalCost: {
                    name: "outTotalCost",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                subscription: {
                    name: "subscription",
                    type: "String",
                    optional: true
                },
                type: {
                    name: "type",
                    type: "ConvoType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("chat") }] }] as readonly AttributeApplication[],
                    default: "chat" as FieldDefault
                },
                finishReason: {
                    name: "finishReason",
                    type: "String",
                    optional: true
                },
                serviceTier: {
                    name: "serviceTier",
                    type: "ServiceTier",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("default") }] }] as readonly AttributeApplication[],
                    default: "default" as FieldDefault
                },
                modelName: {
                    name: "modelName",
                    type: "String",
                    optional: true
                },
                score: {
                    name: "score",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[]
                },
                state: {
                    name: "state",
                    type: "RunState",
                    optional: true
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                },
                initiatedAt: {
                    name: "initiatedAt",
                    type: "DateTime",
                    optional: true
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                completedAt: {
                    name: "completedAt",
                    type: "DateTime",
                    optional: true
                },
                steps: {
                    name: "steps",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                convoId: {
                    name: "convoId",
                    type: "String",
                    foreignKeyFor: [
                        "convo"
                    ] as readonly string[]
                },
                convo: {
                    name: "convo",
                    type: "Convo",
                    relation: { opposite: "aiMessages", fields: ["convoId"], references: ["id"], onDelete: "Cascade" }
                },
                aiSteps: {
                    name: "aiSteps",
                    type: "AiStep",
                    array: true,
                    relation: { opposite: "aiMessage" }
                },
                discardedAt: {
                    name: "discardedAt",
                    type: "DateTime",
                    optional: true
                },
                compactedThroughMessageId: {
                    name: "compactedThroughMessageId",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Artifact: {
            name: "Artifact",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                artifactKey: {
                    name: "artifactKey",
                    type: "String"
                },
                type: {
                    name: "type",
                    type: "String"
                },
                content: {
                    name: "content",
                    type: "String"
                },
                display: {
                    name: "display",
                    type: "String",
                    optional: true
                },
                keep: {
                    name: "keep",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                convoId: {
                    name: "convoId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "convo"
                    ] as readonly string[]
                },
                convo: {
                    name: "convo",
                    type: "Convo",
                    optional: true,
                    relation: { opposite: "artifacts", fields: ["convoId"], references: ["id"], onDelete: "SetNull" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        ConnectionItem: {
            name: "ConnectionItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    relation: { opposite: "connectionItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    relation: { opposite: "connectionItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    isDiscriminator: true
                },
                scope: {
                    name: "scope",
                    type: "ConnectionOwnerScope",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                toolAccessMode: {
                    name: "toolAccessMode",
                    type: "ToolAccessMode",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("READ_ONLY") }] }] as readonly AttributeApplication[],
                    default: "READ_ONLY" as FieldDefault
                },
                status: {
                    name: "status",
                    type: "ConnectionStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("INITIALIZING") }] }] as readonly AttributeApplication[],
                    default: "INITIALIZING" as FieldDefault
                },
                statusReason: {
                    name: "statusReason",
                    type: "String",
                    optional: true
                },
                connectorKey: {
                    name: "connectorKey",
                    type: "String",
                    fuzzy: true
                },
                lastSyncedAt: {
                    name: "lastSyncedAt",
                    type: "DateTime",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            },
            isDelegate: true,
            subModels: ["ComposioConnection", "OsConnection", "CloudConnection"]
        },
        Session: {
            name: "Session",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                token: {
                    name: "token",
                    type: "String",
                    unique: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                ipAddress: {
                    name: "ipAddress",
                    type: "String",
                    optional: true
                },
                userAgent: {
                    name: "userAgent",
                    type: "String",
                    optional: true
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "sessions", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                token: { type: "String" }
            }
        },
        Verification: {
            name: "Verification",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                identifier: {
                    name: "identifier",
                    type: "String"
                },
                value: {
                    name: "value",
                    type: "String"
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                identifier_value: { identifier: { type: "String" }, value: { type: "String" } }
            }
        },
        ApiKey: {
            name: "ApiKey",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                name: {
                    name: "name",
                    type: "String"
                },
                prefix: {
                    name: "prefix",
                    type: "String"
                },
                key: {
                    name: "key",
                    type: "String"
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "apiKeys", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime",
                    optional: true
                },
                lastRequest: {
                    name: "lastRequest",
                    type: "DateTime",
                    optional: true
                },
                requestCount: {
                    name: "requestCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                rateLimitMax: {
                    name: "rateLimitMax",
                    type: "Int",
                    optional: true
                },
                rateLimitTimeWindow: {
                    name: "rateLimitTimeWindow",
                    type: "Int",
                    optional: true
                },
                remaining: {
                    name: "remaining",
                    type: "Int",
                    optional: true
                },
                refillAmount: {
                    name: "refillAmount",
                    type: "Int",
                    optional: true
                },
                refillInterval: {
                    name: "refillInterval",
                    type: "Int",
                    optional: true
                },
                lastRefillAt: {
                    name: "lastRefillAt",
                    type: "DateTime",
                    optional: true
                },
                enabled: {
                    name: "enabled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                permissions: {
                    name: "permissions",
                    type: "Json",
                    optional: true
                },
                metadata: {
                    name: "metadata",
                    type: "Json",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Feedback: {
            name: "Feedback",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                type: {
                    name: "type",
                    type: "FeedbackType",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("feedback") }] }] as readonly AttributeApplication[],
                    default: "feedback" as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(3) }, { name: "max", value: ExpressionUtils.literal(5000) }] }] as readonly AttributeApplication[]
                },
                pageUrl: {
                    name: "pageUrl",
                    type: "String",
                    optional: true
                },
                stepsToReproduce: {
                    name: "stepsToReproduce",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(0) }, { name: "max", value: ExpressionUtils.literal(5000) }] }] as readonly AttributeApplication[]
                },
                screenshotIds: {
                    name: "screenshotIds",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                submittedAt: {
                    name: "submittedAt",
                    type: "DateTime",
                    optional: true
                },
                readAt: {
                    name: "readAt",
                    type: "DateTime",
                    optional: true
                },
                closedAt: {
                    name: "closedAt",
                    type: "DateTime",
                    optional: true
                },
                notes: {
                    name: "notes",
                    type: "String",
                    optional: true,
                    fullText: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(0) }, { name: "max", value: ExpressionUtils.literal(5000) }] }] as readonly AttributeApplication[]
                },
                aiMessageId: {
                    name: "aiMessageId",
                    type: "String",
                    optional: true
                },
                toolCallId: {
                    name: "toolCallId",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        AiModel: {
            name: "AiModel",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                integration: {
                    name: "integration",
                    type: "String"
                },
                modelName: {
                    name: "modelName",
                    type: "String"
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String"
                },
                inContext: {
                    name: "inContext",
                    type: "Int"
                },
                outContext: {
                    name: "outContext",
                    type: "Int"
                },
                dimensions: {
                    name: "dimensions",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                inMegaTokCost: {
                    name: "inMegaTokCost",
                    type: "Float",
                    optional: true
                },
                outMegaTokCost: {
                    name: "outMegaTokCost",
                    type: "Float",
                    optional: true
                },
                cachedMegaTokCost: {
                    name: "cachedMegaTokCost",
                    type: "Float",
                    optional: true
                },
                cacheWriteMegaTokCost: {
                    name: "cacheWriteMegaTokCost",
                    type: "Float",
                    optional: true
                },
                audioInMegaTokCost: {
                    name: "audioInMegaTokCost",
                    type: "Float",
                    optional: true
                },
                audioInMinuteCost: {
                    name: "audioInMinuteCost",
                    type: "Float",
                    optional: true
                },
                modalities: {
                    name: "modalities",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                features: {
                    name: "features",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                endpoints: {
                    name: "endpoints",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                useCases: {
                    name: "useCases",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                benchmarkSlug: {
                    name: "benchmarkSlug",
                    type: "String",
                    optional: true
                },
                reasoning: {
                    name: "reasoning",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                speed: {
                    name: "speed",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(3) }] }] as readonly AttributeApplication[],
                    default: 3 as FieldDefault
                },
                intelligenceIndex: {
                    name: "intelligenceIndex",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                tokensPerSec: {
                    name: "tokensPerSec",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                schemaInPrompt: {
                    name: "schemaInPrompt",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                disabled: {
                    name: "disabled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                releasedAt: {
                    name: "releasedAt",
                    type: "DateTime"
                },
                knowledgeAt: {
                    name: "knowledgeAt",
                    type: "DateTime"
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                prices: {
                    name: "prices",
                    type: "AiModelPrice",
                    array: true,
                    relation: { opposite: "aiModel" }
                },
                scores: {
                    name: "scores",
                    type: "AiModelScore",
                    array: true,
                    relation: { opposite: "aiModel" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                modelName: { type: "String" }
            }
        },
        AiModelPrice: {
            name: "AiModelPrice",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                aiModelId: {
                    name: "aiModelId",
                    type: "String",
                    foreignKeyFor: [
                        "aiModel"
                    ] as readonly string[]
                },
                aiModel: {
                    name: "aiModel",
                    type: "AiModel",
                    relation: { opposite: "prices", fields: ["aiModelId"], references: ["id"], onDelete: "Cascade" }
                },
                serviceTier: {
                    name: "serviceTier",
                    type: "ServiceTier"
                },
                minPromptTokens: {
                    name: "minPromptTokens",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                inMegaTokCost: {
                    name: "inMegaTokCost",
                    type: "Float",
                    optional: true
                },
                cachedMegaTokCost: {
                    name: "cachedMegaTokCost",
                    type: "Float",
                    optional: true
                },
                cacheWriteMegaTokCost: {
                    name: "cacheWriteMegaTokCost",
                    type: "Float",
                    optional: true
                },
                outMegaTokCost: {
                    name: "outMegaTokCost",
                    type: "Float",
                    optional: true
                },
                audioInMegaTokCost: {
                    name: "audioInMegaTokCost",
                    type: "Float",
                    optional: true
                },
                audioInMinuteCost: {
                    name: "audioInMinuteCost",
                    type: "Float",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                aiModelId_serviceTier_minPromptTokens: { aiModelId: { type: "String" }, serviceTier: { type: "ServiceTier" }, minPromptTokens: { type: "Int" } }
            }
        },
        AiModelScore: {
            name: "AiModelScore",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                aiModelId: {
                    name: "aiModelId",
                    type: "String",
                    foreignKeyFor: [
                        "aiModel"
                    ] as readonly string[]
                },
                aiModel: {
                    name: "aiModel",
                    type: "AiModel",
                    relation: { opposite: "scores", fields: ["aiModelId"], references: ["id"], onDelete: "Cascade" }
                },
                reasoningEffort: {
                    name: "reasoningEffort",
                    type: "ReasoningEffort"
                },
                useCases: {
                    name: "useCases",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                benchmarkModel: {
                    name: "benchmarkModel",
                    type: "String",
                    optional: true
                },
                intelligenceIndex: {
                    name: "intelligenceIndex",
                    type: "Int",
                    optional: true
                },
                codingIndex: {
                    name: "codingIndex",
                    type: "Int",
                    optional: true
                },
                agenticIndex: {
                    name: "agenticIndex",
                    type: "Int",
                    optional: true
                },
                longContextIndex: {
                    name: "longContextIndex",
                    type: "Int",
                    optional: true
                },
                tokensPerSec: {
                    name: "tokensPerSec",
                    type: "Int",
                    optional: true
                },
                cursorBenchScore: {
                    name: "cursorBenchScore",
                    type: "Int",
                    optional: true
                },
                costPerTask: {
                    name: "costPerTask",
                    type: "Float",
                    optional: true
                },
                tokensPerTask: {
                    name: "tokensPerTask",
                    type: "Int",
                    optional: true
                },
                stepsPerTask: {
                    name: "stepsPerTask",
                    type: "Int",
                    optional: true
                },
                gpqaScore: {
                    name: "gpqaScore",
                    type: "Int",
                    optional: true
                },
                updatedFromWebAt: {
                    name: "updatedFromWebAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                aiModelId_reasoningEffort: { aiModelId: { type: "String" }, reasoningEffort: { type: "ReasoningEffort" } }
            }
        },
        AiModelPolicyAudit: {
            name: "AiModelPolicyAudit",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                aiModelId: {
                    name: "aiModelId",
                    type: "String"
                },
                modelName: {
                    name: "modelName",
                    type: "String"
                },
                reasoningEffort: {
                    name: "reasoningEffort",
                    type: "String",
                    optional: true
                },
                actingUserId: {
                    name: "actingUserId",
                    type: "String"
                },
                before: {
                    name: "before",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                after: {
                    name: "after",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                outOfSync: {
                    name: "outOfSync",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                gateTodoId: {
                    name: "gateTodoId",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        McpServer: {
            name: "McpServer",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    unique: true,
                    fuzzy: true
                },
                transport: {
                    name: "transport",
                    type: "McpTransport",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("stdio") }] }] as readonly AttributeApplication[],
                    default: "stdio" as FieldDefault
                },
                command: {
                    name: "command",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("") }] }] as readonly AttributeApplication[],
                    default: "" as FieldDefault
                },
                args: {
                    name: "args",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                url: {
                    name: "url",
                    type: "String",
                    optional: true,
                    fuzzy: true
                },
                headers: {
                    name: "headers",
                    type: "Json",
                    optional: true
                },
                env: {
                    name: "env",
                    type: "Json",
                    optional: true
                },
                timeout: {
                    name: "timeout",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(30000) }] }] as readonly AttributeApplication[],
                    default: 30000 as FieldDefault
                },
                initTimeout: {
                    name: "initTimeout",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(30000) }] }] as readonly AttributeApplication[],
                    default: 30000 as FieldDefault
                },
                alwaysOn: {
                    name: "alwaysOn",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                idleTimeoutMs: {
                    name: "idleTimeoutMs",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(60000) }] }] as readonly AttributeApplication[],
                    default: 60000 as FieldDefault
                },
                instructions: {
                    name: "instructions",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                icon: {
                    name: "icon",
                    type: "String",
                    optional: true
                },
                iconPrefix: {
                    name: "iconPrefix",
                    type: "String",
                    optional: true
                },
                catalogTools: {
                    name: "catalogTools",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                catalogToolEntries: {
                    name: "catalogToolEntries",
                    type: "Json",
                    optional: true
                },
                catalogServerVersion: {
                    name: "catalogServerVersion",
                    type: "String",
                    optional: true
                },
                catalogCacheStatus: {
                    name: "catalogCacheStatus",
                    type: "McpCatalogCacheStatus",
                    optional: true
                },
                catalogError: {
                    name: "catalogError",
                    type: "String",
                    optional: true
                },
                catalogFetchedAt: {
                    name: "catalogFetchedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                name: { type: "String" }
            }
        },
        ComposioAuthConfig: {
            name: "ComposioAuthConfig",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                toolkitSlug: {
                    name: "toolkitSlug",
                    type: "String",
                    fuzzy: true
                },
                authScheme: {
                    name: "authScheme",
                    type: "ConnectionAuthScheme"
                },
                authConfigId: {
                    name: "authConfigId",
                    type: "String",
                    unique: true,
                    fuzzy: true
                },
                isComposioManaged: {
                    name: "isComposioManaged",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                enabled: {
                    name: "enabled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                scopes: {
                    name: "scopes",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                initiationFields: {
                    name: "initiationFields",
                    type: "Json",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                connections: {
                    name: "connections",
                    type: "ComposioConnection",
                    array: true,
                    relation: { opposite: "authConfig" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                authConfigId: { type: "String" },
                toolkitSlug_authScheme: { toolkitSlug: { type: "String" }, authScheme: { type: "ConnectionAuthScheme" } }
            }
        },
        ComposioConnection: {
            name: "ComposioConnection",
            baseModel: "ConnectionItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "ConnectionItem",
                    relation: { opposite: "connectionItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "ConnectionItem",
                    relation: { opposite: "connectionItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ConnectionItem",
                    isDiscriminator: true
                },
                scope: {
                    name: "scope",
                    type: "ConnectionOwnerScope",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                toolAccessMode: {
                    name: "toolAccessMode",
                    type: "ToolAccessMode",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("READ_ONLY") }] }] as readonly AttributeApplication[],
                    default: "READ_ONLY" as FieldDefault
                },
                status: {
                    name: "status",
                    type: "ConnectionStatus",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("INITIALIZING") }] }] as readonly AttributeApplication[],
                    default: "INITIALIZING" as FieldDefault
                },
                statusReason: {
                    name: "statusReason",
                    type: "String",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                connectorKey: {
                    name: "connectorKey",
                    type: "String",
                    fuzzy: true,
                    originModel: "ConnectionItem"
                },
                lastSyncedAt: {
                    name: "lastSyncedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                serviceKey: {
                    name: "serviceKey",
                    type: "String",
                    optional: true,
                    fuzzy: true
                },
                connectionUserId: {
                    name: "connectionUserId",
                    type: "String",
                    fuzzy: true
                },
                toolkitSlug: {
                    name: "toolkitSlug",
                    type: "String",
                    fuzzy: true
                },
                toolkitName: {
                    name: "toolkitName",
                    type: "String",
                    optional: true,
                    fuzzy: true
                },
                toolkitLogo: {
                    name: "toolkitLogo",
                    type: "String",
                    optional: true
                },
                authScheme: {
                    name: "authScheme",
                    type: "ConnectionAuthScheme"
                },
                authConfigId: {
                    name: "authConfigId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "authConfig"
                    ] as readonly string[]
                },
                authConfig: {
                    name: "authConfig",
                    type: "ComposioAuthConfig",
                    optional: true,
                    relation: { opposite: "connections", fields: ["authConfigId"], references: ["id"], onDelete: "SetNull" }
                },
                connectedAccountId: {
                    name: "connectedAccountId",
                    type: "String",
                    unique: true,
                    optional: true,
                    omit: true
                },
                isDefault: {
                    name: "isDefault",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                wordId: {
                    name: "wordId",
                    type: "String",
                    optional: true,
                    omit: true
                },
                connectedByUserId: {
                    name: "connectedByUserId",
                    type: "String",
                    optional: true
                },
                initiatedAt: {
                    name: "initiatedAt",
                    type: "DateTime",
                    optional: true
                },
                connectedAt: {
                    name: "connectedAt",
                    type: "DateTime",
                    optional: true
                },
                lastVerifiedAt: {
                    name: "lastVerifiedAt",
                    type: "DateTime",
                    optional: true
                },
                expiredAt: {
                    name: "expiredAt",
                    type: "DateTime",
                    optional: true
                },
                disabledAt: {
                    name: "disabledAt",
                    type: "DateTime",
                    optional: true
                },
                connectStateNonce: {
                    name: "connectStateNonce",
                    type: "String",
                    unique: true,
                    optional: true,
                    omit: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                connectedAccountId: { type: "String" },
                connectStateNonce: { type: "String" }
            }
        },
        OsConnection: {
            name: "OsConnection",
            baseModel: "ConnectionItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "ConnectionItem",
                    relation: { opposite: "connectionItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "ConnectionItem",
                    relation: { opposite: "connectionItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ConnectionItem",
                    isDiscriminator: true
                },
                scope: {
                    name: "scope",
                    type: "ConnectionOwnerScope",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                toolAccessMode: {
                    name: "toolAccessMode",
                    type: "ToolAccessMode",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("READ_ONLY") }] }] as readonly AttributeApplication[],
                    default: "READ_ONLY" as FieldDefault
                },
                status: {
                    name: "status",
                    type: "ConnectionStatus",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("INITIALIZING") }] }] as readonly AttributeApplication[],
                    default: "INITIALIZING" as FieldDefault
                },
                statusReason: {
                    name: "statusReason",
                    type: "String",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                connectorKey: {
                    name: "connectorKey",
                    type: "String",
                    fuzzy: true,
                    originModel: "ConnectionItem"
                },
                lastSyncedAt: {
                    name: "lastSyncedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                provider: {
                    name: "provider",
                    type: "String"
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ConnectionAuditEvent: {
            name: "ConnectionAuditEvent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                connectionUserId: {
                    name: "connectionUserId",
                    type: "String"
                },
                actingUserId: {
                    name: "actingUserId",
                    type: "String"
                },
                connectionId: {
                    name: "connectionId",
                    type: "String"
                },
                toolkitSlug: {
                    name: "toolkitSlug",
                    type: "String"
                },
                toolSlug: {
                    name: "toolSlug",
                    type: "String"
                },
                connectedAccountId: {
                    name: "connectedAccountId",
                    type: "String",
                    optional: true
                },
                convoId: {
                    name: "convoId",
                    type: "String",
                    optional: true
                },
                argumentsHash: {
                    name: "argumentsHash",
                    type: "String"
                },
                phase: {
                    name: "phase",
                    type: "String"
                },
                outcome: {
                    name: "outcome",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        ConnectionSession: {
            name: "ConnectionSession",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                connectionUserId: {
                    name: "connectionUserId",
                    type: "String",
                    fuzzy: true
                },
                configHash: {
                    name: "configHash",
                    type: "String"
                },
                sessionId: {
                    name: "sessionId",
                    type: "String",
                    unique: true,
                    omit: true
                },
                toolkitSlugs: {
                    name: "toolkitSlugs",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                preset: {
                    name: "preset",
                    type: "String",
                    optional: true
                },
                configVersion: {
                    name: "configVersion",
                    type: "Int",
                    optional: true
                },
                lastUsedAt: {
                    name: "lastUsedAt",
                    type: "DateTime",
                    optional: true
                },
                invalidatedAt: {
                    name: "invalidatedAt",
                    type: "DateTime",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                sessionId: { type: "String" },
                connectionUserId_configHash: { connectionUserId: { type: "String" }, configHash: { type: "String" } }
            }
        },
        ToolkitCatalogCache: {
            name: "ToolkitCatalogCache",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                toolkitSlug: {
                    name: "toolkitSlug",
                    type: "String",
                    unique: true
                },
                toolkitVersion: {
                    name: "toolkitVersion",
                    type: "String",
                    optional: true
                },
                tools: {
                    name: "tools",
                    type: "Json"
                },
                fetchedAt: {
                    name: "fetchedAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                toolkitSlug: { type: "String" }
            }
        },
        UserMetricGroup: {
            name: "UserMetricGroup",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                metricGroupId: {
                    name: "metricGroupId",
                    type: "String",
                    foreignKeyFor: [
                        "metricGroup"
                    ] as readonly string[]
                },
                metricGroup: {
                    name: "metricGroup",
                    type: "MetricGroup",
                    relation: { opposite: "userMetricGroups", fields: ["metricGroupId"], references: ["id"], onDelete: "Cascade" }
                },
                ownerGroupKey: {
                    name: "ownerGroupKey",
                    type: "String",
                    unique: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                ownerGroupKey: { type: "String" }
            }
        },
        MetricGroup: {
            name: "MetricGroup",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                icon: {
                    name: "icon",
                    type: "String",
                    optional: true
                },
                metricIds: {
                    name: "metricIds",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                primaryMetricId: {
                    name: "primaryMetricId",
                    type: "String",
                    optional: true
                },
                staleDays: {
                    name: "staleDays",
                    type: "Int",
                    optional: true
                },
                userMetricGroups: {
                    name: "userMetricGroups",
                    type: "UserMetricGroup",
                    array: true,
                    relation: { opposite: "metricGroup" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        DashboardWidget: {
            name: "DashboardWidget",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                dataType: {
                    name: "dataType",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("metric") }] }] as readonly AttributeApplication[],
                    default: "metric" as FieldDefault
                },
                metricId: {
                    name: "metricId",
                    type: "String",
                    optional: true
                },
                chartType: {
                    name: "chartType",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("solidgauge") }] }] as readonly AttributeApplication[],
                    default: "solidgauge" as FieldDefault
                },
                timePeriods: {
                    name: "timePeriods",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                sortOrder: {
                    name: "sortOrder",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                width: {
                    name: "width",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(3) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        CloudConnection: {
            name: "CloudConnection",
            baseModel: "ConnectionItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "ConnectionItem",
                    relation: { opposite: "connectionItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "ConnectionItem",
                    relation: { opposite: "connectionItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ConnectionItem",
                    isDiscriminator: true
                },
                scope: {
                    name: "scope",
                    type: "ConnectionOwnerScope",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                toolAccessMode: {
                    name: "toolAccessMode",
                    type: "ToolAccessMode",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("READ_ONLY") }] }] as readonly AttributeApplication[],
                    default: "READ_ONLY" as FieldDefault
                },
                status: {
                    name: "status",
                    type: "ConnectionStatus",
                    originModel: "ConnectionItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("INITIALIZING") }] }] as readonly AttributeApplication[],
                    default: "INITIALIZING" as FieldDefault
                },
                statusReason: {
                    name: "statusReason",
                    type: "String",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                connectorKey: {
                    name: "connectorKey",
                    type: "String",
                    fuzzy: true,
                    originModel: "ConnectionItem"
                },
                lastSyncedAt: {
                    name: "lastSyncedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ConnectionItem"
                },
                provider: {
                    name: "provider",
                    type: "String",
                    fuzzy: true
                },
                accessToken: {
                    name: "accessToken",
                    type: "String",
                    optional: true,
                    omit: true
                },
                refreshToken: {
                    name: "refreshToken",
                    type: "String",
                    optional: true,
                    omit: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime",
                    optional: true
                },
                oauthScope: {
                    name: "oauthScope",
                    type: "String",
                    optional: true
                },
                remoteUserId: {
                    name: "remoteUserId",
                    type: "String",
                    optional: true
                },
                initiatedAt: {
                    name: "initiatedAt",
                    type: "DateTime",
                    optional: true
                },
                connectedAt: {
                    name: "connectedAt",
                    type: "DateTime",
                    optional: true
                },
                connectStateNonce: {
                    name: "connectStateNonce",
                    type: "String",
                    unique: true,
                    optional: true,
                    omit: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                connectStateNonce: { type: "String" }
            }
        },
        TodoList: {
            name: "TodoList",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                group: {
                    name: "group",
                    type: "String"
                },
                icon: {
                    name: "icon",
                    type: "String",
                    optional: true
                },
                iconPrefix: {
                    name: "iconPrefix",
                    type: "String",
                    optional: true
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                todoItems: {
                    name: "todoItems",
                    type: "TodoItem",
                    array: true,
                    relation: { opposite: "todoList" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        TodoItem: {
            name: "TodoItem",
            baseModel: "NamedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                name: {
                    name: "name",
                    type: "String",
                    fuzzy: true,
                    fullText: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Name must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    originModel: "NamedItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-zA-Z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "NamedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "NamedItem"
                },
                labels: {
                    name: "labels",
                    type: "ItemLabel",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "item" }
                },
                ratings: {
                    name: "ratings",
                    type: "Rating",
                    array: true,
                    originModel: "NamedItem",
                    relation: { opposite: "namedItem" }
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "NamedItem",
                    isDiscriminator: true
                },
                body: {
                    name: "body",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                state: {
                    name: "state",
                    type: "TodoState",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("empty") }] }] as readonly AttributeApplication[],
                    default: "empty" as FieldDefault
                },
                dueAt: {
                    name: "dueAt",
                    type: "DateTime",
                    optional: true
                },
                doneAt: {
                    name: "doneAt",
                    type: "DateTime",
                    optional: true
                },
                doneBy: {
                    name: "doneBy",
                    type: "String",
                    optional: true
                },
                doneByKind: {
                    name: "doneByKind",
                    type: "TodoActorKind",
                    optional: true
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                todoListId: {
                    name: "todoListId",
                    type: "String",
                    foreignKeyFor: [
                        "todoList"
                    ] as readonly string[]
                },
                todoList: {
                    name: "todoList",
                    type: "TodoList",
                    relation: { opposite: "todoItems", fields: ["todoListId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        Book: {
            name: "Book",
            baseModel: "ResourceItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                version: {
                    name: "version",
                    type: "Int",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem"
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(30) }, { name: "max", value: ExpressionUtils.literal(250) }] }] as readonly AttributeApplication[]
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    originModel: "ResourceItem",
                    foreignKeyFor: [
                        "lifeDomain"
                    ] as readonly string[]
                },
                lifeDomain: {
                    name: "lifeDomain",
                    type: "LifeDomain",
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItems", fields: ["domain"], references: ["domainId"] }
                },
                language: {
                    name: "language",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("en") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z]{2}$") }] }] as readonly AttributeApplication[],
                    default: "en" as FieldDefault
                },
                coverImageId: {
                    name: "coverImageId",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                score: {
                    name: "score",
                    type: "Float",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                category: {
                    name: "category",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                categories: {
                    name: "categories",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                publishedOn: {
                    name: "publishedOn",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                websiteUrl: {
                    name: "websiteUrl",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                copyright: {
                    name: "copyright",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                resTaxonomies: {
                    name: "resTaxonomies",
                    type: "ResTaxonomy",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                resAuthors: {
                    name: "resAuthors",
                    type: "ResAuthor",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resource" }
                },
                resourceLinks: {
                    name: "resourceLinks",
                    type: "ResourceLink",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                cloudImages: {
                    name: "cloudImages",
                    type: "CloudImage",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                transcripts: {
                    name: "transcripts",
                    type: "Transcript",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                sources: {
                    name: "sources",
                    type: "Source",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                programSteps: {
                    name: "programSteps",
                    type: "ProgramStep",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true,
                    originModel: "ResourceItem"
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ResourceItem",
                    isDiscriminator: true
                },
                publisher: {
                    name: "publisher",
                    type: "String",
                    optional: true
                },
                isbn10: {
                    name: "isbn10",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(10) }, { name: "max", value: ExpressionUtils.literal(10) }, { name: "message", value: ExpressionUtils.literal("ISBN-10 must be between 1 and 10 characters") }] }] as readonly AttributeApplication[]
                },
                isbn13: {
                    name: "isbn13",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(13) }, { name: "max", value: ExpressionUtils.literal(13) }, { name: "message", value: ExpressionUtils.literal("ISBN-13 must be between 1 and 13 characters") }] }] as readonly AttributeApplication[]
                },
                copiesSold: {
                    name: "copiesSold",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                pages: {
                    name: "pages",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                edition: {
                    name: "edition",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Edition must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        GoodreadsList: {
            name: "GoodreadsList",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                rank: {
                    name: "rank",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                goodReadsId: {
                    name: "goodReadsId",
                    type: "String",
                    unique: true
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    optional: true,
                    fuzzy: true
                },
                author: {
                    name: "author",
                    type: "String",
                    fuzzy: true
                },
                authorUrl: {
                    name: "authorUrl",
                    type: "String"
                },
                bookUrl: {
                    name: "bookUrl",
                    type: "String"
                },
                imageUrl: {
                    name: "imageUrl",
                    type: "String"
                },
                genres: {
                    name: "genres",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true
                },
                isbn10: {
                    name: "isbn10",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(10) }, { name: "max", value: ExpressionUtils.literal(10) }] }] as readonly AttributeApplication[]
                },
                isbn13: {
                    name: "isbn13",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(13) }, { name: "max", value: ExpressionUtils.literal(13) }] }] as readonly AttributeApplication[]
                },
                avgRating: {
                    name: "avgRating",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                ratingsCount: {
                    name: "ratingsCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                score: {
                    name: "score",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                goodReadsId: { type: "String" }
            }
        },
        Podcast: {
            name: "Podcast",
            baseModel: "ResourceItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                version: {
                    name: "version",
                    type: "Int",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem"
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(30) }, { name: "max", value: ExpressionUtils.literal(250) }] }] as readonly AttributeApplication[]
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    originModel: "ResourceItem",
                    foreignKeyFor: [
                        "lifeDomain"
                    ] as readonly string[]
                },
                lifeDomain: {
                    name: "lifeDomain",
                    type: "LifeDomain",
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItems", fields: ["domain"], references: ["domainId"] }
                },
                language: {
                    name: "language",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("en") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z]{2}$") }] }] as readonly AttributeApplication[],
                    default: "en" as FieldDefault
                },
                coverImageId: {
                    name: "coverImageId",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                score: {
                    name: "score",
                    type: "Float",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                category: {
                    name: "category",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                categories: {
                    name: "categories",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                publishedOn: {
                    name: "publishedOn",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                websiteUrl: {
                    name: "websiteUrl",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                copyright: {
                    name: "copyright",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                resTaxonomies: {
                    name: "resTaxonomies",
                    type: "ResTaxonomy",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                resAuthors: {
                    name: "resAuthors",
                    type: "ResAuthor",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resource" }
                },
                resourceLinks: {
                    name: "resourceLinks",
                    type: "ResourceLink",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                cloudImages: {
                    name: "cloudImages",
                    type: "CloudImage",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                transcripts: {
                    name: "transcripts",
                    type: "Transcript",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                sources: {
                    name: "sources",
                    type: "Source",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                programSteps: {
                    name: "programSteps",
                    type: "ProgramStep",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true,
                    originModel: "ResourceItem"
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ResourceItem",
                    isDiscriminator: true
                },
                rssFeedUrl: {
                    name: "rssFeedUrl",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                managingEditorEmail: {
                    name: "managingEditorEmail",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@email" }] as readonly AttributeApplication[]
                },
                webMasterEmail: {
                    name: "webMasterEmail",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@email" }] as readonly AttributeApplication[]
                },
                lastBuiltAt: {
                    name: "lastBuiltAt",
                    type: "DateTime",
                    optional: true
                },
                docsUrl: {
                    name: "docsUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                software: {
                    name: "software",
                    type: "String",
                    optional: true
                },
                ttlMinutes: {
                    name: "ttlMinutes",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                explicit: {
                    name: "explicit",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^(yes|no|clean)$") }] }] as readonly AttributeApplication[]
                },
                ownerName: {
                    name: "ownerName",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                ownerEmail: {
                    name: "ownerEmail",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@email" }] as readonly AttributeApplication[]
                },
                podcastType: {
                    name: "podcastType",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^(episodic|serial)$") }] }] as readonly AttributeApplication[]
                },
                newFeedUrl: {
                    name: "newFeedUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                block: {
                    name: "block",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                complete: {
                    name: "complete",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                lastEpisodePubDate: {
                    name: "lastEpisodePubDate",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("1900-01-01") }] }, { name: "@date" }] as readonly AttributeApplication[],
                    default: "1900-01-01" as FieldDefault
                },
                podEpisodes: {
                    name: "podEpisodes",
                    type: "PodEpisode",
                    array: true,
                    relation: { opposite: "podcast" }
                },
                channel: {
                    name: "channel",
                    type: "Channel",
                    optional: true,
                    relation: { opposite: "podcast" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                rssFeedUrl: { type: "String" }
            }
        },
        Channel: {
            name: "Channel",
            baseModel: "ResourceItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                version: {
                    name: "version",
                    type: "Int",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem"
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(30) }, { name: "max", value: ExpressionUtils.literal(250) }] }] as readonly AttributeApplication[]
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    originModel: "ResourceItem",
                    foreignKeyFor: [
                        "lifeDomain"
                    ] as readonly string[]
                },
                lifeDomain: {
                    name: "lifeDomain",
                    type: "LifeDomain",
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItems", fields: ["domain"], references: ["domainId"] }
                },
                language: {
                    name: "language",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("en") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z]{2}$") }] }] as readonly AttributeApplication[],
                    default: "en" as FieldDefault
                },
                coverImageId: {
                    name: "coverImageId",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                score: {
                    name: "score",
                    type: "Float",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                category: {
                    name: "category",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                categories: {
                    name: "categories",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                publishedOn: {
                    name: "publishedOn",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                websiteUrl: {
                    name: "websiteUrl",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                copyright: {
                    name: "copyright",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                resTaxonomies: {
                    name: "resTaxonomies",
                    type: "ResTaxonomy",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                resAuthors: {
                    name: "resAuthors",
                    type: "ResAuthor",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resource" }
                },
                resourceLinks: {
                    name: "resourceLinks",
                    type: "ResourceLink",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                cloudImages: {
                    name: "cloudImages",
                    type: "CloudImage",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                transcripts: {
                    name: "transcripts",
                    type: "Transcript",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                sources: {
                    name: "sources",
                    type: "Source",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                programSteps: {
                    name: "programSteps",
                    type: "ProgramStep",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true,
                    originModel: "ResourceItem"
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ResourceItem",
                    isDiscriminator: true
                },
                youtubeChannelId: {
                    name: "youtubeChannelId",
                    type: "String",
                    unique: true
                },
                customUrl: {
                    name: "customUrl",
                    type: "String",
                    optional: true
                },
                viewCount: {
                    name: "viewCount",
                    type: "BigInt",
                    optional: true
                },
                subscriberCount: {
                    name: "subscriberCount",
                    type: "Int",
                    optional: true
                },
                videoCount: {
                    name: "videoCount",
                    type: "Int",
                    optional: true
                },
                uploadsPlaylistId: {
                    name: "uploadsPlaylistId",
                    type: "String",
                    optional: true
                },
                lastVideoPubDate: {
                    name: "lastVideoPubDate",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("1900-01-01") }] }, { name: "@date" }] as readonly AttributeApplication[],
                    default: "1900-01-01" as FieldDefault
                },
                videos: {
                    name: "videos",
                    type: "Video",
                    array: true,
                    relation: { opposite: "channel" }
                },
                podcastId: {
                    name: "podcastId",
                    type: "String",
                    unique: true,
                    optional: true,
                    foreignKeyFor: [
                        "podcast"
                    ] as readonly string[]
                },
                podcast: {
                    name: "podcast",
                    type: "Podcast",
                    optional: true,
                    relation: { opposite: "channel", fields: ["podcastId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                youtubeChannelId: { type: "String" },
                podcastId: { type: "String" }
            }
        },
        Video: {
            name: "Video",
            baseModel: "ResourceItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                version: {
                    name: "version",
                    type: "Int",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem"
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(30) }, { name: "max", value: ExpressionUtils.literal(250) }] }] as readonly AttributeApplication[]
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    originModel: "ResourceItem",
                    foreignKeyFor: [
                        "lifeDomain"
                    ] as readonly string[]
                },
                lifeDomain: {
                    name: "lifeDomain",
                    type: "LifeDomain",
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItems", fields: ["domain"], references: ["domainId"] }
                },
                language: {
                    name: "language",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("en") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z]{2}$") }] }] as readonly AttributeApplication[],
                    default: "en" as FieldDefault
                },
                coverImageId: {
                    name: "coverImageId",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                score: {
                    name: "score",
                    type: "Float",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                category: {
                    name: "category",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                categories: {
                    name: "categories",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                publishedOn: {
                    name: "publishedOn",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                websiteUrl: {
                    name: "websiteUrl",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                copyright: {
                    name: "copyright",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                resTaxonomies: {
                    name: "resTaxonomies",
                    type: "ResTaxonomy",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                resAuthors: {
                    name: "resAuthors",
                    type: "ResAuthor",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resource" }
                },
                resourceLinks: {
                    name: "resourceLinks",
                    type: "ResourceLink",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                cloudImages: {
                    name: "cloudImages",
                    type: "CloudImage",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                transcripts: {
                    name: "transcripts",
                    type: "Transcript",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                sources: {
                    name: "sources",
                    type: "Source",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                programSteps: {
                    name: "programSteps",
                    type: "ProgramStep",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true,
                    originModel: "ResourceItem"
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ResourceItem",
                    isDiscriminator: true
                },
                youtubeVideoId: {
                    name: "youtubeVideoId",
                    type: "String",
                    unique: true
                },
                videoUrl: {
                    name: "videoUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                durationSeconds: {
                    name: "durationSeconds",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                viewCount: {
                    name: "viewCount",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                likeCount: {
                    name: "likeCount",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                commentCount: {
                    name: "commentCount",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                definition: {
                    name: "definition",
                    type: "String",
                    optional: true
                },
                vertical: {
                    name: "vertical",
                    type: "Boolean",
                    optional: true
                },
                caption: {
                    name: "caption",
                    type: "Boolean",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                channelId: {
                    name: "channelId",
                    type: "String",
                    foreignKeyFor: [
                        "channel"
                    ] as readonly string[]
                },
                channel: {
                    name: "channel",
                    type: "Channel",
                    relation: { opposite: "videos", fields: ["channelId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                youtubeVideoId: { type: "String" }
            }
        },
        PodEpisode: {
            name: "PodEpisode",
            baseModel: "ResourceItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                version: {
                    name: "version",
                    type: "Int",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "ResourceItem"
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[0-9a-z_]{3,60}$") }] }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String",
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                subtitle: {
                    name: "subtitle",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(500) }] }] as readonly AttributeApplication[]
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem"
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true,
                    fullText: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(30) }, { name: "max", value: ExpressionUtils.literal(250) }] }] as readonly AttributeApplication[]
                },
                domain: {
                    name: "domain",
                    type: "LifeDomainId",
                    originModel: "ResourceItem",
                    foreignKeyFor: [
                        "lifeDomain"
                    ] as readonly string[]
                },
                lifeDomain: {
                    name: "lifeDomain",
                    type: "LifeDomain",
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItems", fields: ["domain"], references: ["domainId"] }
                },
                language: {
                    name: "language",
                    type: "String",
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("en") }] }, { name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(2) }, { name: "max", value: ExpressionUtils.literal(2) }] }, { name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^[a-z]{2}$") }] }] as readonly AttributeApplication[],
                    default: "en" as FieldDefault
                },
                coverImageId: {
                    name: "coverImageId",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                score: {
                    name: "score",
                    type: "Float",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                scoreCount: {
                    name: "scoreCount",
                    type: "Int",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                category: {
                    name: "category",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                categories: {
                    name: "categories",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                publishedOn: {
                    name: "publishedOn",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@date" }] as readonly AttributeApplication[]
                },
                websiteUrl: {
                    name: "websiteUrl",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                copyright: {
                    name: "copyright",
                    type: "String",
                    optional: true,
                    originModel: "ResourceItem"
                },
                resTaxonomies: {
                    name: "resTaxonomies",
                    type: "ResTaxonomy",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                resAuthors: {
                    name: "resAuthors",
                    type: "ResAuthor",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resource" }
                },
                resourceLinks: {
                    name: "resourceLinks",
                    type: "ResourceLink",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                cloudImages: {
                    name: "cloudImages",
                    type: "CloudImage",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                transcripts: {
                    name: "transcripts",
                    type: "Transcript",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                sources: {
                    name: "sources",
                    type: "Source",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                programSteps: {
                    name: "programSteps",
                    type: "ProgramStep",
                    array: true,
                    originModel: "ResourceItem",
                    relation: { opposite: "resourceItem" }
                },
                tags: {
                    name: "tags",
                    type: "String",
                    array: true,
                    originModel: "ResourceItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                embedding: {
                    name: "embedding",
                    type: "Unsupported",
                    optional: true,
                    originModel: "ResourceItem"
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "ResourceItem",
                    isDiscriminator: true
                },
                guid: {
                    name: "guid",
                    type: "String",
                    unique: true
                },
                pubDate: {
                    name: "pubDate",
                    type: "DateTime",
                    optional: true
                },
                episodeUrl: {
                    name: "episodeUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                previewUrl: {
                    name: "previewUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                enclosureUrl: {
                    name: "enclosureUrl",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url" }] as readonly AttributeApplication[]
                },
                enclosureLength: {
                    name: "enclosureLength",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                enclosureType: {
                    name: "enclosureType",
                    type: "String",
                    optional: true
                },
                durationSeconds: {
                    name: "durationSeconds",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                episode: {
                    name: "episode",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                season: {
                    name: "season",
                    type: "Int",
                    optional: true,
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[]
                },
                episodeType: {
                    name: "episodeType",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^(full|trailer|bonus)$") }] }] as readonly AttributeApplication[]
                },
                explicit: {
                    name: "explicit",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^(yes|no|clean)$") }] }] as readonly AttributeApplication[]
                },
                itunesBlock: {
                    name: "itunesBlock",
                    type: "Boolean",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                podcastId: {
                    name: "podcastId",
                    type: "String",
                    foreignKeyFor: [
                        "podcast"
                    ] as readonly string[]
                },
                podcast: {
                    name: "podcast",
                    type: "Podcast",
                    relation: { opposite: "podEpisodes", fields: ["podcastId"], references: ["id"], onDelete: "Cascade" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                guid: { type: "String" }
            }
        },
        Notification: {
            name: "Notification",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                workflow: {
                    name: "workflow",
                    type: "String"
                },
                data: {
                    name: "data",
                    type: "Json"
                },
                status: {
                    name: "status",
                    type: "String",
                    optional: true
                },
                response: {
                    name: "response",
                    type: "Json",
                    optional: true
                },
                emailStatus: {
                    name: "emailStatus",
                    type: "String",
                    optional: true
                },
                emailDate: {
                    name: "emailDate",
                    type: "DateTime",
                    optional: true
                },
                emailPayload: {
                    name: "emailPayload",
                    type: "Json",
                    optional: true
                },
                smsStatus: {
                    name: "smsStatus",
                    type: "String",
                    optional: true
                },
                smsDate: {
                    name: "smsDate",
                    type: "DateTime",
                    optional: true
                },
                smsPayload: {
                    name: "smsPayload",
                    type: "Json",
                    optional: true
                },
                androidStatus: {
                    name: "androidStatus",
                    type: "String",
                    optional: true
                },
                androidDate: {
                    name: "androidDate",
                    type: "DateTime",
                    optional: true
                },
                androidPayload: {
                    name: "androidPayload",
                    type: "Json",
                    optional: true
                },
                iosStatus: {
                    name: "iosStatus",
                    type: "String",
                    optional: true
                },
                iosDate: {
                    name: "iosDate",
                    type: "DateTime",
                    optional: true
                },
                iosPayload: {
                    name: "iosPayload",
                    type: "Json",
                    optional: true
                },
                webStatus: {
                    name: "webStatus",
                    type: "String",
                    optional: true
                },
                webDate: {
                    name: "webDate",
                    type: "DateTime",
                    optional: true
                },
                webPayload: {
                    name: "webPayload",
                    type: "Json",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Journey: {
            name: "Journey",
            baseModel: "OwnedItem",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true,
                    originModel: "OwnedItem"
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault,
                    foreignKeyFor: [
                        "owner"
                    ] as readonly string[]
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault,
                    foreignKeyFor: [
                        "space"
                    ] as readonly string[]
                },
                owner: {
                    name: "owner",
                    type: "User",
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["ownerId"], references: ["id"], onDelete: "Cascade" }
                },
                space: {
                    name: "space",
                    type: "Space",
                    optional: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "ownedItems", fields: ["spaceId"], references: ["id"], onDelete: "Cascade" }
                },
                private: {
                    name: "private",
                    type: "Boolean",
                    originModel: "OwnedItem",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                itemType: {
                    name: "itemType",
                    type: "String",
                    originModel: "OwnedItem",
                    isDiscriminator: true
                },
                factoidsAsProvenance: {
                    name: "factoidsAsProvenance",
                    type: "Factoid",
                    array: true,
                    originModel: "OwnedItem",
                    relation: { opposite: "provenance", name: "FactoidProvenance" }
                },
                group: {
                    name: "group",
                    type: "String"
                },
                object: {
                    name: "object",
                    type: "String",
                    fuzzy: true
                },
                action: {
                    name: "action",
                    type: "String",
                    fuzzy: true
                },
                eventName: {
                    name: "eventName",
                    type: "String",
                    fuzzy: true
                },
                source: {
                    name: "source",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("server") }] }] as readonly AttributeApplication[],
                    default: "server" as FieldDefault
                },
                occurredAt: {
                    name: "occurredAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                linkedItemType: {
                    name: "linkedItemType",
                    type: "String",
                    optional: true
                },
                linkedItemId: {
                    name: "linkedItemId",
                    type: "String",
                    optional: true
                },
                linkedItemName: {
                    name: "linkedItemName",
                    type: "String",
                    optional: true,
                    fuzzy: true
                },
                properties: {
                    name: "properties",
                    type: "Json",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        TaxonomySearchLog: {
            name: "TaxonomySearchLog",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                searchText: {
                    name: "searchText",
                    type: "String"
                },
                domains: {
                    name: "domains",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                types: {
                    name: "types",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                limit: {
                    name: "limit",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(5) }] }] as readonly AttributeApplication[],
                    default: 5 as FieldDefault
                },
                minSimilarity: {
                    name: "minSimilarity",
                    type: "Float",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0.28) }] }] as readonly AttributeApplication[],
                    default: 0.28 as FieldDefault
                },
                resultCount: {
                    name: "resultCount",
                    type: "Int"
                },
                results: {
                    name: "results",
                    type: "TaxonomySearchResult",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("[]") }] }] as readonly AttributeApplication[],
                    default: "[]" as FieldDefault
                },
                analyzedAt: {
                    name: "analyzedAt",
                    type: "DateTime",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        RepoPackage: {
            name: "RepoPackage",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                type: {
                    name: "type",
                    type: "RepoPackageType"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                relativePath: {
                    name: "relativePath",
                    type: "String"
                },
                workspaceName: {
                    name: "workspaceName",
                    type: "String"
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                },
                missingAt: {
                    name: "missingAt",
                    type: "DateTime",
                    optional: true
                },
                disabled: {
                    name: "disabled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                reviews: {
                    name: "reviews",
                    type: "RepoPackageReview",
                    array: true,
                    relation: { opposite: "repoPackage" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                name: { type: "String" }
            }
        },
        RepoReview: {
            name: "RepoReview",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String"
                },
                abbreviation: {
                    name: "abbreviation",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                description: {
                    name: "description",
                    type: "String"
                },
                recurrence: {
                    name: "recurrence",
                    type: "HabitRecurrence",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("monthly") }] }] as readonly AttributeApplication[],
                    default: "monthly" as FieldDefault
                },
                recurIncrement: {
                    name: "recurIncrement",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(104) }, { name: "message", value: ExpressionUtils.literal("The maximum recurrence is 104") }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                ord: {
                    name: "ord",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                enabled: {
                    name: "enabled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                packages: {
                    name: "packages",
                    type: "RepoPackageReview",
                    array: true,
                    relation: { opposite: "repoReview" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        RepoPackageReview: {
            name: "RepoPackageReview",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                repoPackageId: {
                    name: "repoPackageId",
                    type: "String",
                    foreignKeyFor: [
                        "repoPackage"
                    ] as readonly string[]
                },
                repoPackage: {
                    name: "repoPackage",
                    type: "RepoPackage",
                    relation: { opposite: "reviews", fields: ["repoPackageId"], references: ["id"], onDelete: "Cascade" }
                },
                repoReviewId: {
                    name: "repoReviewId",
                    type: "String",
                    foreignKeyFor: [
                        "repoReview"
                    ] as readonly string[]
                },
                repoReview: {
                    name: "repoReview",
                    type: "RepoReview",
                    relation: { opposite: "packages", fields: ["repoReviewId"], references: ["id"], onDelete: "Cascade" }
                },
                reviewedAt: {
                    name: "reviewedAt",
                    type: "DateTime",
                    optional: true
                },
                state: {
                    name: "state",
                    type: "RunState",
                    optional: true
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                notApplicable: {
                    name: "notApplicable",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                findings: {
                    name: "findings",
                    type: "Int",
                    optional: true
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                },
                costUsd: {
                    name: "costUsd",
                    type: "Float",
                    optional: true
                },
                turns: {
                    name: "turns",
                    type: "Int",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                repoPackageId_repoReviewId: { repoPackageId: { type: "String" }, repoReviewId: { type: "String" } }
            }
        },
        PipelineRun: {
            name: "PipelineRun",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                issueKey: {
                    name: "issueKey",
                    type: "String",
                    unique: true
                },
                issueUuid: {
                    name: "issueUuid",
                    type: "String"
                },
                team: {
                    name: "team",
                    type: "String"
                },
                branch: {
                    name: "branch",
                    type: "String",
                    optional: true
                },
                neonBranch: {
                    name: "neonBranch",
                    type: "String",
                    optional: true
                },
                neonBranchId: {
                    name: "neonBranchId",
                    type: "String",
                    optional: true
                },
                planPath: {
                    name: "planPath",
                    type: "String",
                    optional: true
                },
                stage: {
                    name: "stage",
                    type: "PipelineStage"
                },
                round: {
                    name: "round",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                ciRound: {
                    name: "ciRound",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                selfCheckBounces: {
                    name: "selfCheckBounces",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                roundCause: {
                    name: "roundCause",
                    type: "PipelineRoundCause",
                    optional: true
                },
                stageAgentHarness: {
                    name: "stageAgentHarness",
                    type: "PipelineHarness",
                    optional: true
                },
                stageAgentId: {
                    name: "stageAgentId",
                    type: "String",
                    optional: true
                },
                stageAgentUrl: {
                    name: "stageAgentUrl",
                    type: "String",
                    optional: true
                },
                stageAgentModel: {
                    name: "stageAgentModel",
                    type: "String",
                    optional: true
                },
                buildAgentHarness: {
                    name: "buildAgentHarness",
                    type: "PipelineHarness",
                    optional: true
                },
                buildAgentId: {
                    name: "buildAgentId",
                    type: "String",
                    optional: true
                },
                buildAgentUrl: {
                    name: "buildAgentUrl",
                    type: "String",
                    optional: true
                },
                buildAgentModel: {
                    name: "buildAgentModel",
                    type: "String",
                    optional: true
                },
                buildLaunchNumber: {
                    name: "buildLaunchNumber",
                    type: "Int",
                    optional: true
                },
                planAgentHarness: {
                    name: "planAgentHarness",
                    type: "PipelineHarness",
                    optional: true
                },
                planAgentUrl: {
                    name: "planAgentUrl",
                    type: "String",
                    optional: true
                },
                verifyAgentHarness: {
                    name: "verifyAgentHarness",
                    type: "PipelineHarness",
                    optional: true
                },
                verifyAgentUrl: {
                    name: "verifyAgentUrl",
                    type: "String",
                    optional: true
                },
                prNumber: {
                    name: "prNumber",
                    type: "Int",
                    optional: true
                },
                forgenticPreviewDomain: {
                    name: "forgenticPreviewDomain",
                    type: "String",
                    optional: true
                },
                filesChanged: {
                    name: "filesChanged",
                    type: "Int",
                    optional: true
                },
                linesAdded: {
                    name: "linesAdded",
                    type: "Int",
                    optional: true
                },
                linesRemoved: {
                    name: "linesRemoved",
                    type: "Int",
                    optional: true
                },
                tier: {
                    name: "tier",
                    type: "PipelineTier",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("standard") }] }] as readonly AttributeApplication[],
                    default: "standard" as FieldDefault
                },
                triageTier: {
                    name: "triageTier",
                    type: "PipelineTier",
                    optional: true
                },
                triageTouchesSchema: {
                    name: "triageTouchesSchema",
                    type: "Boolean",
                    optional: true
                },
                triageReady: {
                    name: "triageReady",
                    type: "Boolean",
                    optional: true
                },
                triageNeedsPlan: {
                    name: "triageNeedsPlan",
                    type: "Boolean",
                    optional: true
                },
                turnSandboxId: {
                    name: "turnSandboxId",
                    type: "String",
                    optional: true
                },
                settlingSandboxId: {
                    name: "settlingSandboxId",
                    type: "String",
                    optional: true
                },
                settlingSince: {
                    name: "settlingSince",
                    type: "DateTime",
                    optional: true
                },
                turnCredentialName: {
                    name: "turnCredentialName",
                    type: "String",
                    optional: true
                },
                turnGitKeyHash: {
                    name: "turnGitKeyHash",
                    type: "String",
                    optional: true
                },
                turnOutcome: {
                    name: "turnOutcome",
                    type: "PipelineTurnOutcome",
                    optional: true
                },
                turnAssistantText: {
                    name: "turnAssistantText",
                    type: "String",
                    optional: true
                },
                turnClosingMessage: {
                    name: "turnClosingMessage",
                    type: "String",
                    optional: true
                },
                launchedRunCount: {
                    name: "launchedRunCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                stageErrorCount: {
                    name: "stageErrorCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                stageEnteredAt: {
                    name: "stageEnteredAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                lastError: {
                    name: "lastError",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                issueKey: { type: "String" }
            }
        },
        PipelineRunUsage: {
            name: "PipelineRunUsage",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                issueKey: {
                    name: "issueKey",
                    type: "String"
                },
                stage: {
                    name: "stage",
                    type: "PipelineUsageStage"
                },
                round: {
                    name: "round",
                    type: "Int"
                },
                sessionId: {
                    name: "sessionId",
                    type: "String",
                    unique: true,
                    optional: true
                },
                agentId: {
                    name: "agentId",
                    type: "String",
                    optional: true
                },
                cursorRunId: {
                    name: "cursorRunId",
                    type: "String",
                    optional: true
                },
                turnId: {
                    name: "turnId",
                    type: "String",
                    optional: true
                },
                model: {
                    name: "model",
                    type: "String",
                    optional: true
                },
                inputTokens: {
                    name: "inputTokens",
                    type: "Int",
                    optional: true
                },
                outputTokens: {
                    name: "outputTokens",
                    type: "Int",
                    optional: true
                },
                cacheWriteTokens: {
                    name: "cacheWriteTokens",
                    type: "Int",
                    optional: true
                },
                cacheReadTokens: {
                    name: "cacheReadTokens",
                    type: "Int",
                    optional: true
                },
                costUsd: {
                    name: "costUsd",
                    type: "Decimal",
                    optional: true
                },
                subscription: {
                    name: "subscription",
                    type: "String",
                    optional: true
                },
                paidUsd: {
                    name: "paidUsd",
                    type: "Decimal",
                    optional: true
                },
                usageReadAt: {
                    name: "usageReadAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                sessionId: { type: "String" },
                agentId_cursorRunId: { agentId: { type: "String" }, cursorRunId: { type: "String" } },
                agentId_turnId: { agentId: { type: "String" }, turnId: { type: "String" } }
            }
        },
        PipelineRunCharge: {
            name: "PipelineRunCharge",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                issueKey: {
                    name: "issueKey",
                    type: "String",
                    optional: true
                },
                service: {
                    name: "service",
                    type: "PipelineChargeService"
                },
                resourceId: {
                    name: "resourceId",
                    type: "String"
                },
                quantity: {
                    name: "quantity",
                    type: "Decimal",
                    optional: true
                },
                unit: {
                    name: "unit",
                    type: "String",
                    optional: true
                },
                costUsd: {
                    name: "costUsd",
                    type: "Decimal",
                    optional: true
                },
                subscription: {
                    name: "subscription",
                    type: "String",
                    optional: true
                },
                paidUsd: {
                    name: "paidUsd",
                    type: "Decimal",
                    optional: true
                },
                estimated: {
                    name: "estimated",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                details: {
                    name: "details",
                    type: "Json",
                    optional: true
                },
                periodStart: {
                    name: "periodStart",
                    type: "DateTime",
                    optional: true
                },
                periodEnd: {
                    name: "periodEnd",
                    type: "DateTime",
                    optional: true
                },
                readAt: {
                    name: "readAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                service_resourceId: { service: { type: "PipelineChargeService" }, resourceId: { type: "String" } }
            }
        },
        ForgeProjectState: {
            name: "ForgeProjectState",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                department: {
                    name: "department",
                    type: "String"
                },
                project: {
                    name: "project",
                    type: "String"
                },
                ownerEmail: {
                    name: "ownerEmail",
                    type: "String"
                },
                phase: {
                    name: "phase",
                    type: "String"
                },
                humanGates: {
                    name: "humanGates",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                spawnConvoId: {
                    name: "spawnConvoId",
                    type: "String",
                    optional: true
                },
                gateTodoId: {
                    name: "gateTodoId",
                    type: "String",
                    optional: true
                },
                gatePhase: {
                    name: "gatePhase",
                    type: "String",
                    optional: true
                },
                gateKey: {
                    name: "gateKey",
                    type: "String",
                    optional: true
                },
                blockedAt: {
                    name: "blockedAt",
                    type: "DateTime",
                    optional: true
                },
                blockedReason: {
                    name: "blockedReason",
                    type: "String",
                    optional: true
                },
                blockerTodoId: {
                    name: "blockerTodoId",
                    type: "String",
                    optional: true
                },
                pausedAt: {
                    name: "pausedAt",
                    type: "DateTime",
                    optional: true
                },
                pausedBy: {
                    name: "pausedBy",
                    type: "String",
                    optional: true
                },
                pausedReason: {
                    name: "pausedReason",
                    type: "String",
                    optional: true
                },
                archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    optional: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                department_project: { department: { type: "String" }, project: { type: "String" } }
            }
        },
        SentryIssue: {
            name: "SentryIssue",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                sentryIssueId: {
                    name: "sentryIssueId",
                    type: "String",
                    unique: true
                },
                project: {
                    name: "project",
                    type: "String"
                },
                shortId: {
                    name: "shortId",
                    type: "String"
                },
                permalink: {
                    name: "permalink",
                    type: "String"
                },
                title: {
                    name: "title",
                    type: "String"
                },
                culprit: {
                    name: "culprit",
                    type: "String",
                    optional: true
                },
                level: {
                    name: "level",
                    type: "String"
                },
                productionCount: {
                    name: "productionCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                productionUserCount: {
                    name: "productionUserCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                productionFirstSeen: {
                    name: "productionFirstSeen",
                    type: "DateTime",
                    optional: true
                },
                productionLastSeen: {
                    name: "productionLastSeen",
                    type: "DateTime",
                    optional: true
                },
                productionLastRelease: {
                    name: "productionLastRelease",
                    type: "String",
                    optional: true
                },
                previewCount: {
                    name: "previewCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                previewUserCount: {
                    name: "previewUserCount",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                previewFirstSeen: {
                    name: "previewFirstSeen",
                    type: "DateTime",
                    optional: true
                },
                previewLastSeen: {
                    name: "previewLastSeen",
                    type: "DateTime",
                    optional: true
                },
                previewLastRelease: {
                    name: "previewLastRelease",
                    type: "String",
                    optional: true
                },
                classification: {
                    name: "classification",
                    type: "SentryClassification",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("unclassified") }] }] as readonly AttributeApplication[],
                    default: "unclassified" as FieldDefault
                },
                classificationReason: {
                    name: "classificationReason",
                    type: "String",
                    optional: true
                },
                triageTitle: {
                    name: "triageTitle",
                    type: "String",
                    optional: true
                },
                triageSummary: {
                    name: "triageSummary",
                    type: "String",
                    optional: true
                },
                triageUserImpact: {
                    name: "triageUserImpact",
                    type: "String",
                    optional: true
                },
                triageLinearProject: {
                    name: "triageLinearProject",
                    type: "String",
                    optional: true
                },
                triageSuggestedFix: {
                    name: "triageSuggestedFix",
                    type: "String",
                    optional: true
                },
                triageLikelyFiles: {
                    name: "triageLikelyFiles",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                classifiedAt: {
                    name: "classifiedAt",
                    type: "DateTime",
                    optional: true
                },
                classifiedRelease: {
                    name: "classifiedRelease",
                    type: "String",
                    optional: true
                },
                linearIssueKey: {
                    name: "linearIssueKey",
                    type: "String",
                    optional: true
                },
                linearIssueUrl: {
                    name: "linearIssueUrl",
                    type: "String",
                    optional: true
                },
                linearFilingAt: {
                    name: "linearFilingAt",
                    type: "DateTime",
                    optional: true
                },
                linearState: {
                    name: "linearState",
                    type: "String",
                    optional: true
                },
                fixOnDevAt: {
                    name: "fixOnDevAt",
                    type: "DateTime",
                    optional: true
                },
                fixOnMainAt: {
                    name: "fixOnMainAt",
                    type: "DateTime",
                    optional: true
                },
                sentryStatus: {
                    name: "sentryStatus",
                    type: "String",
                    optional: true
                },
                resolvedBy: {
                    name: "resolvedBy",
                    type: "SentryResolvedBy",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("none") }] }] as readonly AttributeApplication[],
                    default: "none" as FieldDefault
                },
                resolvedAt: {
                    name: "resolvedAt",
                    type: "DateTime",
                    optional: true
                },
                regressedAt: {
                    name: "regressedAt",
                    type: "DateTime",
                    optional: true
                },
                alertedDangerousAt: {
                    name: "alertedDangerousAt",
                    type: "DateTime",
                    optional: true
                },
                alertedUndeployedAt: {
                    name: "alertedUndeployedAt",
                    type: "DateTime",
                    optional: true
                },
                alertedRegressionAt: {
                    name: "alertedRegressionAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                sentryIssueId: { type: "String" }
            }
        },
        Secret: {
            name: "Secret",
            fields: {
                name: {
                    name: "name",
                    type: "String",
                    id: true
                },
                group: {
                    name: "group",
                    type: "String"
                },
                value: {
                    name: "value",
                    type: "String"
                },
                heldBy: {
                    name: "heldBy",
                    type: "String",
                    optional: true
                },
                heldAt: {
                    name: "heldAt",
                    type: "DateTime",
                    optional: true
                },
                writtenAt: {
                    name: "writtenAt",
                    type: "DateTime"
                },
                rejectedAt: {
                    name: "rejectedAt",
                    type: "DateTime",
                    optional: true
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            idFields: ["name"],
            uniqueFields: {
                name: { type: "String" }
            }
        }
    } as const;
    typeDefs = {
        UserBase: {
            name: "UserBase",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true
                },
                email: {
                    name: "email",
                    type: "String",
                    unique: true,
                    fuzzy: true,
                    attributes: [{ name: "@email", args: [{ name: "message", value: ExpressionUtils.literal("Please enter a valid email address") }] }] as readonly AttributeApplication[]
                },
                emailVerified: {
                    name: "emailVerified",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                phoneNumber: {
                    name: "phoneNumber",
                    type: "String",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@regex", args: [{ name: "regex", value: ExpressionUtils.literal("^\\+[1-9][0-9]{9,14}$") }, { name: "message", value: ExpressionUtils.literal("Please enter a valid mobile number") }] }] as readonly AttributeApplication[]
                },
                phoneNumberVerified: {
                    name: "phoneNumberVerified",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                givenName: {
                    name: "givenName",
                    type: "String",
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                familyName: {
                    name: "familyName",
                    type: "String",
                    optional: true,
                    fuzzy: true,
                    attributes: [{ name: "@length", args: [{ name: "max", value: ExpressionUtils.literal(100) }] }] as readonly AttributeApplication[]
                },
                image: {
                    name: "image",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "UserRole",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                privacy: {
                    name: "privacy",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                activeSpaceId: {
                    name: "activeSpaceId",
                    type: "String",
                    optional: true
                },
                repairedAt: {
                    name: "repairedAt",
                    type: "DateTime",
                    optional: true
                },
                spaces: {
                    name: "spaces",
                    type: "SpaceUser",
                    array: true,
                    relation: {}
                },
                accounts: {
                    name: "accounts",
                    type: "Account",
                    array: true,
                    relation: {}
                },
                sessions: {
                    name: "sessions",
                    type: "Session",
                    array: true,
                    relation: {}
                },
                apiKeys: {
                    name: "apiKeys",
                    type: "ApiKey",
                    array: true,
                    relation: {}
                },
                ownedItems: {
                    name: "ownedItems",
                    type: "OwnedItem",
                    array: true,
                    relation: {}
                },
                namedItems: {
                    name: "namedItems",
                    type: "NamedItem",
                    array: true,
                    relation: {}
                },
                settings: {
                    name: "settings",
                    type: "SettingValue",
                    array: true,
                    relation: {}
                },
                connectionItems: {
                    name: "connectionItems",
                    type: "ConnectionItem",
                    array: true,
                    relation: {}
                }
            }
        },
        Base: {
            name: "Base",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                trashedAt: {
                    name: "trashedAt",
                    type: "DateTime",
                    optional: true
                },
                ownerId: {
                    name: "ownerId",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]) as FieldDefault
                },
                spaceId: {
                    name: "spaceId",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.member(ExpressionUtils.call("auth"), ["activeSpaceId"]) as FieldDefault
                }
            }
        },
        Auth: {
            name: "Auth",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "UserRole"
                },
                activeSpaceId: {
                    name: "activeSpaceId",
                    type: "String",
                    optional: true
                },
                privacy: {
                    name: "privacy",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                }
            }
        },
        PromptVariableOption: {
            name: "PromptVariableOption",
            fields: {
                value: {
                    name: "value",
                    type: "String"
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                }
            }
        },
        PromptVariable: {
            name: "PromptVariable",
            fields: {
                name: {
                    name: "name",
                    type: "String"
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                default: {
                    name: "default",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                options: {
                    name: "options",
                    type: "PromptVariableOption",
                    optional: true,
                    array: true
                }
            }
        },
        TaxonomyBase: {
            name: "TaxonomyBase",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                status: {
                    name: "status",
                    type: "PublishStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("draft") }] }] as readonly AttributeApplication[],
                    default: "draft" as FieldDefault
                },
                publishedAt: {
                    name: "publishedAt",
                    type: "DateTime",
                    optional: true
                },
                version: {
                    name: "version",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(1) }] }] as readonly AttributeApplication[],
                    default: 1 as FieldDefault
                },
                indexedAt: {
                    name: "indexedAt",
                    type: "DateTime",
                    optional: true
                },
                processingAt: {
                    name: "processingAt",
                    type: "DateTime",
                    optional: true
                },
                warnings: {
                    name: "warnings",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                }
            }
        },
        QuizAnswer: {
            name: "QuizAnswer",
            fields: {
                label: {
                    name: "label",
                    type: "String"
                },
                value: {
                    name: "value",
                    type: "String"
                },
                score: {
                    name: "score",
                    type: "Int",
                    attributes: [{ name: "@gte", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }, { name: "@lte", args: [{ name: "value", value: ExpressionUtils.literal(10) }] }] as readonly AttributeApplication[]
                }
            }
        },
        SocialAccount: {
            name: "SocialAccount",
            fields: {
                platform: {
                    name: "platform",
                    type: "String"
                },
                url: {
                    name: "url",
                    type: "String",
                    attributes: [{ name: "@url", args: [{ name: "message", value: ExpressionUtils.literal("Please enter a valid URL") }] }] as readonly AttributeApplication[]
                },
                username: {
                    name: "username",
                    type: "String"
                }
            }
        },
        Source: {
            name: "Source",
            fields: {
                type: {
                    name: "type",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("source") }] }] as readonly AttributeApplication[],
                    default: "source" as FieldDefault
                },
                sourceType: {
                    name: "sourceType",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("url") }] }] as readonly AttributeApplication[],
                    default: "url" as FieldDefault
                },
                url: {
                    name: "url",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@url", args: [{ name: "message", value: ExpressionUtils.literal("Please enter a valid URL") }] }] as readonly AttributeApplication[]
                },
                title: {
                    name: "title",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@length", args: [{ name: "min", value: ExpressionUtils.literal(1) }, { name: "max", value: ExpressionUtils.literal(100) }, { name: "message", value: ExpressionUtils.literal("Title must be between 1 and 100 characters") }] }] as readonly AttributeApplication[]
                }
            }
        },
        BotOverrides: {
            name: "BotOverrides",
            fields: {
                modelOverride: {
                    name: "modelOverride",
                    type: "String",
                    optional: true
                },
                useCase: {
                    name: "useCase",
                    type: "String",
                    optional: true
                },
                integration: {
                    name: "integration",
                    type: "String",
                    optional: true
                },
                modelName: {
                    name: "modelName",
                    type: "String",
                    optional: true
                },
                systemPromptOverride: {
                    name: "systemPromptOverride",
                    type: "String",
                    optional: true
                },
                systemPromptAppend: {
                    name: "systemPromptAppend",
                    type: "String",
                    optional: true
                },
                temperature: {
                    name: "temperature",
                    type: "Float",
                    optional: true
                },
                reasoningEffort: {
                    name: "reasoningEffort",
                    type: "String",
                    optional: true
                },
                maxSteps: {
                    name: "maxSteps",
                    type: "Int",
                    optional: true
                }
            }
        },
        TaxonomySearchResult: {
            name: "TaxonomySearchResult",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                similarity: {
                    name: "similarity",
                    type: "Float"
                }
            }
        }
    } as const;
    enums = {
        Gender: {
            name: "Gender",
            values: {
                Male: "Male",
                Female: "Female",
                NonBinary: "NonBinary",
                Other: "Other",
                PreferNotToSay: "PreferNotToSay"
            }
        },
        RelationshipStatus: {
            name: "RelationshipStatus",
            values: {
                Single: "Single",
                Married: "Married",
                Divorced: "Divorced",
                Widowed: "Widowed",
                Partnered: "Partnered",
                Other: "Other",
                PreferNotToSay: "PreferNotToSay"
            }
        },
        CoachId: {
            name: "CoachId",
            values: {
                coach_blaze: "coach_blaze",
                dr_pragmatic: "dr_pragmatic",
                buddy_sam: "buddy_sam",
                sage_rowan: "sage_rowan",
                cora_bloom: "cora_bloom",
                theo_sage: "theo_sage",
                sergeant_knox: "sergeant_knox",
                sky_zephyr: "sky_zephyr",
                master_tao: "master_tao",
                avery_planwell: "avery_planwell"
            }
        },
        OnboardingTrack: {
            name: "OnboardingTrack",
            values: {
                specific: "specific",
                expedited: "expedited",
                comprehensive: "comprehensive"
            }
        },
        UserRole: {
            name: "UserRole",
            values: {
                USER: "USER",
                ADMIN: "ADMIN",
                TEAM: "TEAM",
                AGENT: "AGENT"
            }
        },
        SpaceUserRole: {
            name: "SpaceUserRole",
            values: {
                USER: "USER",
                ADMIN: "ADMIN"
            }
        },
        SettingType: {
            name: "SettingType",
            values: {
                string: "string",
                number: "number",
                boolean: "boolean",
                date: "date",
                object: "object"
            }
        },
        ConvoSpawnMode: {
            name: "ConvoSpawnMode",
            values: {
                direct: "direct",
                sync: "sync",
                async: "async"
            }
        },
        ConvoType: {
            name: "ConvoType",
            values: {
                chat: "chat",
                completion: "completion",
                forge: "forge",
                agent: "agent",
                analysis: "analysis",
                embedding: "embedding",
                decision: "decision",
                transcription: "transcription"
            }
        },
        RatingType: {
            name: "RatingType",
            values: {
                four_thumbs: "four_thumbs"
            }
        },
        LabelType: {
            name: "LabelType",
            values: {
                AUTO: "AUTO",
                FAVORITES: "FAVORITES",
                SEEDED: "SEEDED",
                CUSTOM: "CUSTOM"
            }
        },
        ReasoningEffort: {
            name: "ReasoningEffort",
            values: {
                none: "none",
                minimal: "minimal",
                low: "low",
                medium: "medium",
                high: "high",
                xhigh: "xhigh",
                max: "max"
            }
        },
        PublishStatus: {
            name: "PublishStatus",
            values: {
                draft: "draft",
                review: "review",
                approve: "approve",
                published: "published",
                rejected: "rejected",
                archived: "archived"
            }
        },
        TaxonomyType: {
            name: "TaxonomyType",
            values: {
                issue: "issue",
                aspiration: "aspiration",
                practice: "practice"
            }
        },
        LifeDomainId: {
            name: "LifeDomainId",
            values: {
                body: "body",
                mind: "mind",
                home: "home",
                intimacy: "intimacy",
                community: "community",
                school: "school",
                work: "work",
                business: "business",
                money: "money",
                parenting: "parenting",
                caregiving: "caregiving",
                play: "play",
                growth: "growth",
                purpose: "purpose",
                general: "general"
            }
        },
        MetricCategory: {
            name: "MetricCategory",
            values: {
                body: "body",
                fitness: "fitness",
                health: "health",
                custom: "custom"
            }
        },
        MetricBaseRule: {
            name: "MetricBaseRule",
            values: {
                last: "last",
                highest: "highest",
                lowest: "lowest",
                average: "average",
                median: "median",
                sum: "sum"
            }
        },
        MetricChartType: {
            name: "MetricChartType",
            values: {
                line: "line",
                bar: "bar",
                heatmap: "heatmap"
            }
        },
        MetricDirection: {
            name: "MetricDirection",
            values: {
                higher: "higher",
                lower: "lower"
            }
        },
        DashboardTimePeriod: {
            name: "DashboardTimePeriod",
            values: {
                today: "today",
                yesterday: "yesterday",
                sevenDayAvg: "sevenDayAvg",
                thirtyDayAvg: "thirtyDayAvg",
                todayYestSeven: "todayYestSeven",
                recent: "recent"
            }
        },
        HabitEndType: {
            name: "HabitEndType",
            values: {
                phase: "phase",
                program: "program",
                never: "never"
            }
        },
        HabitRecurrence: {
            name: "HabitRecurrence",
            values: {
                none: "none",
                daily: "daily",
                weekly: "weekly",
                monthly: "monthly",
                yearly: "yearly"
            }
        },
        HabitCompletion: {
            name: "HabitCompletion",
            values: {
                empty: "empty",
                skipped: "skipped",
                partial: "partial",
                done: "done"
            }
        },
        HabitCompletedBy: {
            name: "HabitCompletedBy",
            values: {
                user: "user",
                auto: "auto",
                ai: "ai"
            }
        },
        TimeBlock: {
            name: "TimeBlock",
            values: {
                wakeup: "wakeup",
                morning: "morning",
                lunch: "lunch",
                afternoon: "afternoon",
                dinner: "dinner",
                evening: "evening",
                bedtime: "bedtime",
                time: "time"
            }
        },
        Effort: {
            name: "Effort",
            values: {
                trivial: "trivial",
                easy: "easy",
                medium: "medium",
                hard: "hard"
            }
        },
        Measure: {
            name: "Measure",
            values: {
                mass: "mass",
                length: "length",
                volume: "volume",
                energy: "energy",
                time: "time",
                count: "count",
                ratio: "ratio",
                distance: "distance",
                scale: "scale",
                money: "money",
                sleep: "sleep",
                temp: "temp",
                tempDelta: "tempDelta",
                pressure: "pressure",
                glucose: "glucose"
            }
        },
        UnitSystem: {
            name: "UnitSystem",
            values: {
                metric: "metric",
                us: "us",
                none: "none"
            }
        },
        QuizQuestionType: {
            name: "QuizQuestionType",
            values: {
                scale: "scale",
                boolean: "boolean",
                multiple_choice: "multiple_choice",
                freeform: "freeform"
            }
        },
        QuizResultState: {
            name: "QuizResultState",
            values: {
                PENDING: "PENDING",
                INITIALIZING: "INITIALIZING",
                STARTED: "STARTED",
                PAUSED: "PAUSED",
                CONTINUED: "CONTINUED",
                COMPLETED: "COMPLETED",
                SCORED: "SCORED"
            }
        },
        QuizResultBracket: {
            name: "QuizResultBracket",
            values: {
                Thriving: "Thriving",
                Steady: "Steady",
                Uneven: "Uneven",
                Challenged: "Challenged",
                InCrisis: "InCrisis"
            }
        },
        ProgramLevel: {
            name: "ProgramLevel",
            values: {
                intro: "intro",
                beginner: "beginner",
                intermediate: "intermediate",
                advanced: "advanced",
                pro: "pro"
            }
        },
        ProgramStepType: {
            name: "ProgramStepType",
            values: {
                html: "html",
                md: "md",
                interview: "interview",
                youtubeUrl: "youtubeUrl",
                podcastUrl: "podcastUrl",
                podEpisode: "podEpisode",
                youtubeVideo: "youtubeVideo"
            }
        },
        ProgramLessonUnlock: {
            name: "ProgramLessonUnlock",
            values: {
                sequential: "sequential",
                open: "open"
            }
        },
        ProgramMetricRole: {
            name: "ProgramMetricRole",
            values: {
                outcome: "outcome",
                behavior: "behavior"
            }
        },
        ProgramParameterType: {
            name: "ProgramParameterType",
            values: {
                number: "number",
                choice: "choice",
                boolean: "boolean",
                text: "text"
            }
        },
        UserProgramStatus: {
            name: "UserProgramStatus",
            values: {
                current: "current",
                paused: "paused",
                completed: "completed",
                abandoned: "abandoned"
            }
        },
        UserProgramNodeType: {
            name: "UserProgramNodeType",
            values: {
                phase: "phase",
                lesson: "lesson",
                step: "step"
            }
        },
        UserProgramNodeState: {
            name: "UserProgramNodeState",
            values: {
                future: "future",
                started: "started",
                completed: "completed",
                failed: "failed"
            }
        },
        ResourcePlatformId: {
            name: "ResourcePlatformId",
            values: {
                amazon_us: "amazon_us",
                amazon_uk: "amazon_uk",
                amazon_ca: "amazon_ca",
                audible_us: "audible_us",
                audible_uk: "audible_uk",
                audible_ca: "audible_ca",
                goodreads: "goodreads",
                google_books: "google_books",
                open_library: "open_library",
                megaphone: "megaphone",
                podchaser: "podchaser",
                spreaker: "spreaker",
                apple_podcasts: "apple_podcasts",
                spotify_shows: "spotify_shows",
                youtube: "youtube",
                youtube_podcasts: "youtube_podcasts",
                rss: "rss",
                unknown: "unknown"
            }
        },
        ResourceFormat: {
            name: "ResourceFormat",
            values: {
                hardcover: "hardcover",
                paperback: "paperback",
                kindle: "kindle",
                ebook: "ebook",
                audiobook: "audiobook",
                podcast: "podcast",
                episode: "episode",
                channel: "channel",
                video: "video",
                website: "website",
                blog: "blog",
                article: "article",
                newsletter: "newsletter",
                rss: "rss",
                other: "other"
            }
        },
        PriceType: {
            name: "PriceType",
            values: {
                not_listed: "not_listed",
                not_available: "not_available",
                free: "free",
                once: "once",
                monthly: "monthly",
                quarterly: "quarterly",
                annual: "annual"
            }
        },
        ToolSetEntryKind: {
            name: "ToolSetEntryKind",
            values: {
                mcp_server: "mcp_server",
                native_group: "native_group"
            }
        },
        AiStepCostSource: {
            name: "AiStepCostSource",
            values: {
                price: "price",
                provider: "provider",
                copied: "copied"
            }
        },
        SeverityLevel: {
            name: "SeverityLevel",
            values: {
                fatal: "fatal",
                error: "error",
                warning: "warning",
                success: "success",
                log: "log",
                info: "info",
                debug: "debug"
            }
        },
        ExecutionSignal: {
            name: "ExecutionSignal",
            values: {
                pause: "pause",
                stop: "stop"
            }
        },
        RunState: {
            name: "RunState",
            values: {
                waiting: "waiting",
                pending: "pending",
                running: "running",
                paused: "paused",
                stopped: "stopped",
                unauth: "unauth",
                timeout: "timeout",
                hung: "hung",
                noop: "noop",
                failed: "failed",
                notfound: "notfound",
                ok: "ok",
                warning: "warning"
            }
        },
        AiMessageRole: {
            name: "AiMessageRole",
            values: {
                system: "system",
                user: "user",
                assistant: "assistant"
            }
        },
        ServiceTier: {
            name: "ServiceTier",
            values: {
                auto: "auto",
                flex: "flex",
                priority: "priority",
                default: "default",
                batch: "batch",
                ultrafast: "ultrafast"
            }
        },
        Verbosity: {
            name: "Verbosity",
            values: {
                low: "low",
                medium: "medium",
                high: "high",
                auto: "auto"
            }
        },
        ConvoVerbosity: {
            name: "ConvoVerbosity",
            values: {
                low: "low",
                medium: "medium",
                high: "high"
            }
        },
        ConnectionOwnerScope: {
            name: "ConnectionOwnerScope",
            values: {
                USER: "USER",
                SPACE: "SPACE",
                SERVICE: "SERVICE"
            }
        },
        ToolAccessMode: {
            name: "ToolAccessMode",
            values: {
                READ_ONLY: "READ_ONLY",
                READ_WRITE: "READ_WRITE"
            }
        },
        ConnectionStatus: {
            name: "ConnectionStatus",
            values: {
                INITIALIZING: "INITIALIZING",
                INITIATED: "INITIATED",
                ACTIVE: "ACTIVE",
                FAILED: "FAILED",
                EXPIRED: "EXPIRED",
                INACTIVE: "INACTIVE",
                REVOKED: "REVOKED"
            }
        },
        ConnectionAuthScheme: {
            name: "ConnectionAuthScheme",
            values: {
                OAUTH2: "OAUTH2",
                OAUTH1: "OAUTH1",
                API_KEY: "API_KEY",
                BASIC: "BASIC",
                BILLCOM_AUTH: "BILLCOM_AUTH",
                BEARER_TOKEN: "BEARER_TOKEN",
                GOOGLE_SERVICE_ACCOUNT: "GOOGLE_SERVICE_ACCOUNT",
                NO_AUTH: "NO_AUTH",
                BASIC_WITH_JWT: "BASIC_WITH_JWT",
                CALCOM_AUTH: "CALCOM_AUTH",
                SERVICE_ACCOUNT: "SERVICE_ACCOUNT",
                SAML: "SAML",
                DCR_OAUTH: "DCR_OAUTH",
                S2S_OAUTH2: "S2S_OAUTH2"
            }
        },
        FeedbackType: {
            name: "FeedbackType",
            values: {
                question: "question",
                feedback: "feedback",
                bug: "bug",
                request: "request"
            }
        },
        McpCatalogCacheStatus: {
            name: "McpCatalogCacheStatus",
            values: {
                ok: "ok",
                error: "error"
            }
        },
        McpTransport: {
            name: "McpTransport",
            values: {
                stdio: "stdio",
                http: "http",
                sse: "sse"
            }
        },
        TodoState: {
            name: "TodoState",
            values: {
                empty: "empty",
                started: "started",
                unverified: "unverified",
                blocked: "blocked",
                done: "done"
            }
        },
        TodoActorKind: {
            name: "TodoActorKind",
            values: {
                human: "human",
                agent: "agent"
            }
        },
        RepoPackageType: {
            name: "RepoPackageType",
            values: {
                app: "app",
                package: "package"
            }
        },
        PipelineStage: {
            name: "PipelineStage",
            values: {
                triage: "triage",
                needs_input: "needs_input",
                planning: "planning",
                plan_review: "plan_review",
                building: "building",
                verifying: "verifying",
                in_review: "in_review",
                merging: "merging",
                done: "done",
                cancelled: "cancelled"
            }
        },
        PipelineRoundCause: {
            name: "PipelineRoundCause",
            values: {
                defects: "defects",
                ci: "ci",
                conflict: "conflict"
            }
        },
        PipelineHarness: {
            name: "PipelineHarness",
            values: {
                claude_anthropic: "claude_anthropic",
                cursor_cursor: "cursor_cursor",
                codex_railway: "codex_railway"
            }
        },
        PipelineTier: {
            name: "PipelineTier",
            values: {
                simple: "simple",
                standard: "standard",
                complex: "complex"
            }
        },
        PipelineTurnOutcome: {
            name: "PipelineTurnOutcome",
            values: {
                finished: "finished",
                error: "error",
                usage_limited: "usage_limited"
            }
        },
        PipelineUsageStage: {
            name: "PipelineUsageStage",
            values: {
                plan: "plan",
                build: "build",
                verify: "verify"
            }
        },
        PipelineChargeService: {
            name: "PipelineChargeService",
            values: {
                bot: "bot",
                vercel: "vercel",
                github_actions: "github_actions",
                railway: "railway",
                neon: "neon"
            }
        },
        SentryClassification: {
            name: "SentryClassification",
            values: {
                unclassified: "unclassified",
                noise: "noise",
                transient: "transient",
                needs_fix: "needs_fix",
                dangerous: "dangerous"
            }
        },
        SentryResolvedBy: {
            name: "SentryResolvedBy",
            values: {
                none: "none",
                noise: "noise",
                quiet: "quiet",
                fix: "fix"
            }
        }
    } as const;
    authType = "Auth" as const;
    plugins = {};
}
export const schema = new SchemaType();
